import BigNumber from 'bignumber.js';
import { Contract, ethers, utils, BigNumber as BigNumber$1 } from 'ethers';
import { groupBy, uniq } from 'ramda';
import { Pool } from '@uniswap/v3-sdk/';
import { Token } from '@uniswap/sdk-core';
import { abi as abi$3 } from '@uniswap/v3-core/artifacts/contracts/interfaces/IUniswapV3Pool.sol/IUniswapV3Pool.json';
import ExpiryMap from 'expiry-map';
import pMemoize from 'p-memoize';
import { InheritableEventEmitter } from '@akolos/event-emitter';
import { OnomyClientErrors, OnomyClient } from '@onomy/client';
import { Bech32 } from '@cosmjs/encoding';

const DEFAULT_FIAT_CURRENCY = "USDT";
const ONOMY_CHAIN = { name: "onomy" };
const ETH_CHAIN = { name: "goerli" };
const NOM_ASSET = {
  chain: ONOMY_CHAIN,
  id: "anom",
  meta: {
    symbol: "NOM",
    name: "NOM",
    decimalPlaces: 18
  }
};
const ETH_ASSET = {
  chain: ETH_CHAIN,
  id: "0x0000000000000000000000000000000000000001",
  meta: {
    symbol: "ETH",
    name: "Ether",
    decimalPlaces: 18
  }
};
const BNOM_ASSET = {
  chain: ETH_CHAIN,
  id: "0x8EFe26D6839108E831D3a37cA503eA4F136A8E73",
  meta: {
    symbol: "bNOM",
    name: "Bonding NOM",
    decimalPlaces: 18
  }
};
const ETH_NOM_ASSET = {
  chain: ETH_CHAIN,
  id: "0x9653a2013e23ae976d34543572e3e72f8578e4c6",
  meta: {
    symbol: "NOM",
    name: "NOM on ETH",
    decimalPlaces: 18
  }
};
const UNKNOWN_ASSET_META = {
  name: "Unknown Asset",
  symbol: "???",
  decimalPlaces: 18
};
const UNKNOWN_BALANCE = {
  asset: {
    ...NOM_ASSET,
    meta: UNKNOWN_ASSET_META
  },
  amount: BigInt(0),
  fiatPrice: 0,
  fiatCurrency: DEFAULT_FIAT_CURRENCY,
  fiatValue: 0,
  amountFormatted: "0"
};
function updateAssetData({
  ethChainId,
  nomAsset,
  ethAsset,
  bNomAsset,
  ethNomAsset
}) {
  if (ethChainId) {
    ETH_CHAIN.name = ethChainId;
    OnomyHubConstants.ETH_CHAIN_ID = ethChainId;
  }
  if (nomAsset) {
    const newNomAsset = { ...OnomyHubConstants.NOM_ASSET, ...nomAsset };
    OnomyHubConstants.NOM_ASSET = newNomAsset;
  }
  if (ethAsset) {
    const newEthAsset = { ...OnomyHubConstants.ETH_ASSET, ...ethAsset };
    OnomyHubConstants.ETH_ASSET = newEthAsset;
  }
  if (bNomAsset) {
    const newBNomAsset = { ...OnomyHubConstants.BNOM_ASSET, ...bNomAsset };
    OnomyHubConstants.BNOM_ASSET = newBNomAsset;
  }
  if (ethNomAsset) {
    const newEthNomAsset = { ...OnomyHubConstants.ETH_NOM_ASSET, ...ethNomAsset };
    OnomyHubConstants.ETH_NOM_ASSET = newEthNomAsset;
  }
  OnomyHubConstants.SUPPORTED_CHAINS = [OnomyHubConstants.ONOMY_CHAIN, OnomyHubConstants.ETH_CHAIN];
  OnomyHubConstants.SUPPORTED_ASSETS = [
    OnomyHubConstants.NOM_ASSET,
    OnomyHubConstants.ETH_ASSET,
    OnomyHubConstants.BNOM_ASSET,
    OnomyHubConstants.ETH_NOM_ASSET
  ];
}
function isAssetEqual(a, cmp) {
  const asset = "asset" in cmp ? cmp.asset : cmp;
  return a.chain.name === asset.chain.name && a.id === asset.id;
}
function isAssetNOM(cmp) {
  return OnomyHubConstants.isAssetEqual(OnomyHubConstants.NOM_ASSET, cmp);
}
function isAssetBNOM(cmp) {
  return OnomyHubConstants.isAssetEqual(OnomyHubConstants.BNOM_ASSET, cmp);
}
function isAssetEthNom(cmp) {
  return OnomyHubConstants.isAssetEqual(OnomyHubConstants.ETH_NOM_ASSET, cmp);
}
function isAssetETH(cmp) {
  return OnomyHubConstants.isAssetEqual(OnomyHubConstants.ETH_ASSET, cmp);
}
const OnomyHubConstants = {
  ONOMY_CHAIN,
  ETH_CHAIN,
  NOM_ASSET,
  ETH_ASSET,
  BNOM_ASSET,
  ETH_NOM_ASSET,
  ETH_CHAIN_ID: ETH_CHAIN.name,
  ONOMY_CHAIN_ID: ONOMY_CHAIN.name,
  DEFAULT_FIAT_CURRENCY,
  UNKNOWN_ASSET_META,
  UNKNOWN_BALANCE,
  SUPPORTED_CHAINS: [ONOMY_CHAIN, ETH_CHAIN],
  SUPPORTED_ASSETS: [NOM_ASSET, ETH_ASSET, BNOM_ASSET, ETH_NOM_ASSET],
  ETH_GAS_PRICE_URL: "",
  updateAssetData,
  isAssetEqual,
  isAssetNOM,
  isAssetBNOM,
  isAssetETH,
  isAssetEthNom
};

var _format$2 = "hh-sol-artifact-1";
var contractName$2 = "ERC20NOM";
var sourceName$2 = "contracts/ERC20NOM.sol";
var abi$2 = [
	{
		inputs: [
		],
		stateMutability: "nonpayable",
		type: "constructor"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "owner",
				type: "address"
			},
			{
				indexed: true,
				internalType: "address",
				name: "spender",
				type: "address"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "value",
				type: "uint256"
			}
		],
		name: "Approval",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "from",
				type: "address"
			},
			{
				indexed: true,
				internalType: "address",
				name: "to",
				type: "address"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "value",
				type: "uint256"
			}
		],
		name: "Transfer",
		type: "event"
	},
	{
		inputs: [
		],
		name: "INITIAL_SUPPLY",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "owner",
				type: "address"
			},
			{
				internalType: "address",
				name: "spender",
				type: "address"
			}
		],
		name: "allowance",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "spender",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "amount",
				type: "uint256"
			}
		],
		name: "approve",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "account",
				type: "address"
			}
		],
		name: "balanceOf",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "amount",
				type: "uint256"
			}
		],
		name: "burn",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "account",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "amount",
				type: "uint256"
			}
		],
		name: "burnFrom",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
		],
		name: "decimals",
		outputs: [
			{
				internalType: "uint8",
				name: "",
				type: "uint8"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "spender",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "subtractedValue",
				type: "uint256"
			}
		],
		name: "decreaseAllowance",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "spender",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "addedValue",
				type: "uint256"
			}
		],
		name: "increaseAllowance",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
		],
		name: "name",
		outputs: [
			{
				internalType: "string",
				name: "",
				type: "string"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "symbol",
		outputs: [
			{
				internalType: "string",
				name: "",
				type: "string"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "totalSupply",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "recipient",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "amount",
				type: "uint256"
			}
		],
		name: "transfer",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "sender",
				type: "address"
			},
			{
				internalType: "address",
				name: "recipient",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "amount",
				type: "uint256"
			}
		],
		name: "transferFrom",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	}
];
var bytecode$2 = "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";
var deployedBytecode$2 = "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";
var linkReferences$2 = {
};
var deployedLinkReferences$2 = {
};
var ERC20ContractJSON = {
	_format: _format$2,
	contractName: contractName$2,
	sourceName: sourceName$2,
	abi: abi$2,
	bytecode: bytecode$2,
	deployedBytecode: deployedBytecode$2,
	linkReferences: linkReferences$2,
	deployedLinkReferences: deployedLinkReferences$2
};

var _format$1 = "hh-sol-artifact-1";
var contractName$1 = "BondingNOM";
var sourceName$1 = "contracts/BondingNOM.sol";
var abi$1 = [
	{
		inputs: [
			{
				internalType: "address",
				name: "NOMContAddr",
				type: "address"
			}
		],
		stateMutability: "nonpayable",
		type: "constructor"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "previousOwner",
				type: "address"
			},
			{
				indexed: true,
				internalType: "address",
				name: "newOwner",
				type: "address"
			}
		],
		name: "OwnershipTransferred",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "_by",
				type: "address"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "amountNOM",
				type: "uint256"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "amountETH",
				type: "uint256"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "price",
				type: "uint256"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "supply",
				type: "uint256"
			},
			{
				indexed: false,
				internalType: "string",
				name: "buyOrSell",
				type: "string"
			},
			{
				indexed: false,
				internalType: "int256",
				name: "slippage",
				type: "int256"
			}
		],
		name: "Transaction",
		type: "event"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "supplyTop",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "supplyBot",
				type: "uint256"
			}
		],
		name: "NOMSupToETH",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "NOMTokenContract",
		outputs: [
			{
				internalType: "address",
				name: "",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "a",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "burnedNOM",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "estAmountNOM",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "allowSlip",
				type: "uint256"
			}
		],
		name: "buyNOM",
		outputs: [
		],
		stateMutability: "payable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "amountETH",
				type: "uint256"
			}
		],
		name: "buyQuoteETH",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "amountNOM",
				type: "uint256"
			}
		],
		name: "buyQuoteNOM",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "x",
				type: "uint256"
			}
		],
		name: "cubrtu",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "pure",
		type: "function"
	},
	{
		inputs: [
		],
		name: "decimals",
		outputs: [
			{
				internalType: "uint8",
				name: "",
				type: "uint8"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "enableTrading",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "int128",
				name: "fixed64",
				type: "int128"
			}
		],
		name: "f64ToTok",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "getBondPrice",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "getNOMAddr",
		outputs: [
			{
				internalType: "address",
				name: "",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "getSupplyNOM",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "getTradingEnabled",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "owner",
		outputs: [
			{
				internalType: "address",
				name: "",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "_supplyNOM",
				type: "uint256"
			}
		],
		name: "priceAtSupply",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "priceBondCurve",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "renounceOwnership",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "amountNOM",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "estAmountETH",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "allowSlip",
				type: "uint256"
			}
		],
		name: "sellNOM",
		outputs: [
		],
		stateMutability: "payable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "amountNOM",
				type: "uint256"
			}
		],
		name: "sellQuoteNOM",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "price",
				type: "uint256"
			}
		],
		name: "supplyAtPrice",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "supplyNOM",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "teamBalance",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "token",
				type: "uint256"
			}
		],
		name: "tokToF64",
		outputs: [
			{
				internalType: "int128",
				name: "",
				type: "int128"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "tradingEnabled",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "newOwner",
				type: "address"
			}
		],
		name: "transferOwnership",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
		],
		name: "withdraw",
		outputs: [
			{
				internalType: "bool",
				name: "success",
				type: "bool"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	}
];
var bytecode$1 = "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";
var deployedBytecode$1 = "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";
var linkReferences$1 = {
};
var deployedLinkReferences$1 = {
};
var BondingContractJSON = {
	_format: _format$1,
	contractName: contractName$1,
	sourceName: sourceName$1,
	abi: abi$1,
	bytecode: bytecode$1,
	deployedBytecode: deployedBytecode$1,
	linkReferences: linkReferences$1,
	deployedLinkReferences: deployedLinkReferences$1
};

var _format = "hh-sol-artifact-1";
var contractName = "Gravity";
var sourceName = "contracts/Gravity.sol";
var abi = [
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "_gravityId",
				type: "bytes32"
			},
			{
				internalType: "address[]",
				name: "_validators",
				type: "address[]"
			},
			{
				internalType: "uint256[]",
				name: "_powers",
				type: "uint256[]"
			},
			{
				internalType: "address",
				name: "_wNomAddress",
				type: "address"
			}
		],
		stateMutability: "nonpayable",
		type: "constructor"
	},
	{
		inputs: [
		],
		name: "BatchTimedOut",
		type: "error"
	},
	{
		inputs: [
		],
		name: "IncorrectCheckpoint",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "cumulativePower",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "powerThreshold",
				type: "uint256"
			}
		],
		name: "InsufficientPower",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "newNonce",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "currentNonce",
				type: "uint256"
			}
		],
		name: "InvalidBatchNonce",
		type: "error"
	},
	{
		inputs: [
		],
		name: "InvalidLogicCallFees",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "newNonce",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "currentNonce",
				type: "uint256"
			}
		],
		name: "InvalidLogicCallNonce",
		type: "error"
	},
	{
		inputs: [
		],
		name: "InvalidLogicCallTransfers",
		type: "error"
	},
	{
		inputs: [
		],
		name: "InvalidSendToCosmos",
		type: "error"
	},
	{
		inputs: [
		],
		name: "InvalidSignature",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "newNonce",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "currentNonce",
				type: "uint256"
			}
		],
		name: "InvalidValsetNonce",
		type: "error"
	},
	{
		inputs: [
		],
		name: "LogicCallTimedOut",
		type: "error"
	},
	{
		inputs: [
		],
		name: "MalformedBatch",
		type: "error"
	},
	{
		inputs: [
		],
		name: "MalformedCurrentValidatorSet",
		type: "error"
	},
	{
		inputs: [
		],
		name: "MalformedNewValidatorSet",
		type: "error"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "string",
				name: "_cosmosDenom",
				type: "string"
			},
			{
				indexed: true,
				internalType: "address",
				name: "_tokenContract",
				type: "address"
			},
			{
				indexed: false,
				internalType: "string",
				name: "_name",
				type: "string"
			},
			{
				indexed: false,
				internalType: "string",
				name: "_symbol",
				type: "string"
			},
			{
				indexed: false,
				internalType: "uint8",
				name: "_decimals",
				type: "uint8"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "_eventNonce",
				type: "uint256"
			}
		],
		name: "ERC20DeployedEvent",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "bytes32",
				name: "_invalidationId",
				type: "bytes32"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "_invalidationNonce",
				type: "uint256"
			},
			{
				indexed: false,
				internalType: "bytes",
				name: "_returnData",
				type: "bytes"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "_eventNonce",
				type: "uint256"
			}
		],
		name: "LogicCallEvent",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "_tokenContract",
				type: "address"
			},
			{
				indexed: true,
				internalType: "address",
				name: "_sender",
				type: "address"
			},
			{
				indexed: false,
				internalType: "string",
				name: "_destination",
				type: "string"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "_amount",
				type: "uint256"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "_eventNonce",
				type: "uint256"
			}
		],
		name: "SendToCosmosEvent",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "uint256",
				name: "_batchNonce",
				type: "uint256"
			},
			{
				indexed: true,
				internalType: "address",
				name: "_token",
				type: "address"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "_eventNonce",
				type: "uint256"
			}
		],
		name: "TransactionBatchExecutedEvent",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "uint256",
				name: "_newValsetNonce",
				type: "uint256"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "_eventNonce",
				type: "uint256"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "_rewardAmount",
				type: "uint256"
			},
			{
				indexed: false,
				internalType: "address",
				name: "_rewardToken",
				type: "address"
			},
			{
				indexed: false,
				internalType: "address[]",
				name: "_validators",
				type: "address[]"
			},
			{
				indexed: false,
				internalType: "uint256[]",
				name: "_powers",
				type: "uint256[]"
			}
		],
		name: "ValsetUpdatedEvent",
		type: "event"
	},
	{
		inputs: [
			{
				internalType: "string",
				name: "_cosmosDenom",
				type: "string"
			},
			{
				internalType: "string",
				name: "_name",
				type: "string"
			},
			{
				internalType: "string",
				name: "_symbol",
				type: "string"
			},
			{
				internalType: "uint8",
				name: "_decimals",
				type: "uint8"
			}
		],
		name: "deployERC20",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "_erc20Address",
				type: "address"
			}
		],
		name: "lastBatchNonce",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "_invalidation_id",
				type: "bytes32"
			}
		],
		name: "lastLogicCallNonce",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "_tokenContract",
				type: "address"
			},
			{
				internalType: "string",
				name: "_destination",
				type: "string"
			},
			{
				internalType: "uint256",
				name: "_amount",
				type: "uint256"
			}
		],
		name: "sendToCosmos",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
		],
		name: "state_gravityId",
		outputs: [
			{
				internalType: "bytes32",
				name: "",
				type: "bytes32"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "",
				type: "bytes32"
			}
		],
		name: "state_invalidationMapping",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "",
				type: "address"
			}
		],
		name: "state_lastBatchNonces",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "state_lastEventNonce",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "state_lastValsetCheckpoint",
		outputs: [
			{
				internalType: "bytes32",
				name: "",
				type: "bytes32"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "state_lastValsetNonce",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				components: [
					{
						internalType: "address[]",
						name: "validators",
						type: "address[]"
					},
					{
						internalType: "uint256[]",
						name: "powers",
						type: "uint256[]"
					},
					{
						internalType: "uint256",
						name: "valsetNonce",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "rewardAmount",
						type: "uint256"
					},
					{
						internalType: "address",
						name: "rewardToken",
						type: "address"
					}
				],
				internalType: "struct ValsetArgs",
				name: "_currentValset",
				type: "tuple"
			},
			{
				components: [
					{
						internalType: "uint8",
						name: "v",
						type: "uint8"
					},
					{
						internalType: "bytes32",
						name: "r",
						type: "bytes32"
					},
					{
						internalType: "bytes32",
						name: "s",
						type: "bytes32"
					}
				],
				internalType: "struct Signature[]",
				name: "_sigs",
				type: "tuple[]"
			},
			{
				internalType: "uint256[]",
				name: "_amounts",
				type: "uint256[]"
			},
			{
				internalType: "address[]",
				name: "_destinations",
				type: "address[]"
			},
			{
				internalType: "uint256[]",
				name: "_fees",
				type: "uint256[]"
			},
			{
				internalType: "uint256",
				name: "_batchNonce",
				type: "uint256"
			},
			{
				internalType: "address",
				name: "_tokenContract",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "_batchTimeout",
				type: "uint256"
			}
		],
		name: "submitBatch",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				components: [
					{
						internalType: "address[]",
						name: "validators",
						type: "address[]"
					},
					{
						internalType: "uint256[]",
						name: "powers",
						type: "uint256[]"
					},
					{
						internalType: "uint256",
						name: "valsetNonce",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "rewardAmount",
						type: "uint256"
					},
					{
						internalType: "address",
						name: "rewardToken",
						type: "address"
					}
				],
				internalType: "struct ValsetArgs",
				name: "_currentValset",
				type: "tuple"
			},
			{
				components: [
					{
						internalType: "uint8",
						name: "v",
						type: "uint8"
					},
					{
						internalType: "bytes32",
						name: "r",
						type: "bytes32"
					},
					{
						internalType: "bytes32",
						name: "s",
						type: "bytes32"
					}
				],
				internalType: "struct Signature[]",
				name: "_sigs",
				type: "tuple[]"
			},
			{
				components: [
					{
						internalType: "uint256[]",
						name: "transferAmounts",
						type: "uint256[]"
					},
					{
						internalType: "address[]",
						name: "transferTokenContracts",
						type: "address[]"
					},
					{
						internalType: "uint256[]",
						name: "feeAmounts",
						type: "uint256[]"
					},
					{
						internalType: "address[]",
						name: "feeTokenContracts",
						type: "address[]"
					},
					{
						internalType: "address",
						name: "logicContractAddress",
						type: "address"
					},
					{
						internalType: "bytes",
						name: "payload",
						type: "bytes"
					},
					{
						internalType: "uint256",
						name: "timeOut",
						type: "uint256"
					},
					{
						internalType: "bytes32",
						name: "invalidationId",
						type: "bytes32"
					},
					{
						internalType: "uint256",
						name: "invalidationNonce",
						type: "uint256"
					}
				],
				internalType: "struct LogicCallArgs",
				name: "_args",
				type: "tuple"
			}
		],
		name: "submitLogicCall",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				components: [
					{
						internalType: "address[]",
						name: "validators",
						type: "address[]"
					},
					{
						internalType: "uint256[]",
						name: "powers",
						type: "uint256[]"
					},
					{
						internalType: "uint256",
						name: "valsetNonce",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "rewardAmount",
						type: "uint256"
					},
					{
						internalType: "address",
						name: "rewardToken",
						type: "address"
					}
				],
				internalType: "struct ValsetArgs",
				name: "_currentValset",
				type: "tuple"
			},
			{
				components: [
					{
						internalType: "uint8",
						name: "v",
						type: "uint8"
					},
					{
						internalType: "bytes32",
						name: "r",
						type: "bytes32"
					},
					{
						internalType: "bytes32",
						name: "s",
						type: "bytes32"
					}
				],
				internalType: "struct Signature[]",
				name: "_sigs",
				type: "tuple[]"
			},
			{
				internalType: "bytes32",
				name: "_theHash",
				type: "bytes32"
			},
			{
				internalType: "uint256",
				name: "_powerThreshold",
				type: "uint256"
			}
		],
		name: "testCheckValidatorSignatures",
		outputs: [
		],
		stateMutability: "pure",
		type: "function"
	},
	{
		inputs: [
			{
				components: [
					{
						internalType: "address[]",
						name: "validators",
						type: "address[]"
					},
					{
						internalType: "uint256[]",
						name: "powers",
						type: "uint256[]"
					},
					{
						internalType: "uint256",
						name: "valsetNonce",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "rewardAmount",
						type: "uint256"
					},
					{
						internalType: "address",
						name: "rewardToken",
						type: "address"
					}
				],
				internalType: "struct ValsetArgs",
				name: "_valsetArgs",
				type: "tuple"
			},
			{
				internalType: "bytes32",
				name: "_gravityId",
				type: "bytes32"
			}
		],
		name: "testMakeCheckpoint",
		outputs: [
		],
		stateMutability: "pure",
		type: "function"
	},
	{
		inputs: [
			{
				components: [
					{
						internalType: "address[]",
						name: "validators",
						type: "address[]"
					},
					{
						internalType: "uint256[]",
						name: "powers",
						type: "uint256[]"
					},
					{
						internalType: "uint256",
						name: "valsetNonce",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "rewardAmount",
						type: "uint256"
					},
					{
						internalType: "address",
						name: "rewardToken",
						type: "address"
					}
				],
				internalType: "struct ValsetArgs",
				name: "_newValset",
				type: "tuple"
			},
			{
				components: [
					{
						internalType: "address[]",
						name: "validators",
						type: "address[]"
					},
					{
						internalType: "uint256[]",
						name: "powers",
						type: "uint256[]"
					},
					{
						internalType: "uint256",
						name: "valsetNonce",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "rewardAmount",
						type: "uint256"
					},
					{
						internalType: "address",
						name: "rewardToken",
						type: "address"
					}
				],
				internalType: "struct ValsetArgs",
				name: "_currentValset",
				type: "tuple"
			},
			{
				components: [
					{
						internalType: "uint8",
						name: "v",
						type: "uint8"
					},
					{
						internalType: "bytes32",
						name: "r",
						type: "bytes32"
					},
					{
						internalType: "bytes32",
						name: "s",
						type: "bytes32"
					}
				],
				internalType: "struct Signature[]",
				name: "_sigs",
				type: "tuple[]"
			}
		],
		name: "updateValset",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
		],
		name: "wNomAddress",
		outputs: [
			{
				internalType: "address",
				name: "",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	}
];
var bytecode = "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";
var deployedBytecode = "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";
var linkReferences = {
};
var deployedLinkReferences = {
};
var GravityContractJSON = {
	_format: _format,
	contractName: contractName,
	sourceName: sourceName,
	abi: abi,
	bytecode: bytecode,
	deployedBytecode: deployedBytecode,
	linkReferences: linkReferences,
	deployedLinkReferences: deployedLinkReferences
};

function ERC20Cont(address, signer) {
  const ABI = ERC20ContractJSON.abi;
  return new Contract(address, ABI, signer);
}
function BondingCont(address, signer) {
  const ABI = BondingContractJSON.abi;
  return new Contract(address, ABI, signer);
}
function GravityCont(address, signer) {
  const ABI = GravityContractJSON.abi;
  return new Contract(address, ABI, signer);
}

class TypedEvent {
  constructor() {
    this.listeners = [];
    this.listenersOncer = [];
    this.on = (listener) => {
      this.listeners.push(listener);
      return {
        dispose: () => this.off(listener)
      };
    };
    this.once = (listener) => {
      this.listenersOncer.push(listener);
    };
    this.off = (listener) => {
      const callbackIndex = this.listeners.indexOf(listener);
      if (callbackIndex > -1)
        this.listeners.splice(callbackIndex, 1);
    };
    this.emit = (event) => {
      this.listeners.forEach((listener) => listener(event));
      if (this.listenersOncer.length > 0) {
        const toCall = this.listenersOncer;
        this.listenersOncer = [];
        toCall.forEach((listener) => listener(event));
      }
    };
    this.pipe = (te) => {
      return this.on((e) => te.emit(e));
    };
  }
}

class AbstractAssetBridge {
  constructor(chains, prices, balances) {
    this.chains = chains;
    this.prices = prices;
    this.balances = balances;
    this.onApprovedAmountUpdate = this.onApprovedAmountUpdate.bind(this);
  }
  async estimateApproveGas(params) {
    return "0";
  }
  async calculateMax(params) {
    const gasAsset = this.getGasAsset();
    const isGasFromAsset = OnomyHubConstants.isAssetEqual(gasAsset, params.amount);
    const [fromBalance, estGas] = await Promise.all([
      this.getFromBalance(),
      isGasFromAsset ? this.estimateTxGas(params) : Promise.resolve("0")
    ]);
    return {
      ...params,
      amount: {
        ...params.amount,
        amount: fromBalance.amount - BigInt(estGas)
      }
    };
  }
  async calculateMaxApprove(params) {
    if (!this.getRequiresApproval())
      return params;
    const [fromBalance, approvedAmount] = await Promise.all([
      this.getFromBalance(),
      this.getApprovedAmount()
    ]);
    return {
      ...params,
      amount: {
        ...params.amount,
        amount: fromBalance.amount - approvedAmount.amount
      }
    };
  }
  async getFromBalance(address) {
    return this.balances.get(this.getFromAsset(), address);
  }
  async getToBalance(address) {
    return this.balances.get(this.getToAsset(), address);
  }
  async getGasBalance(address) {
    return this.balances.get(this.getGasAsset(), address);
  }
  async getBridgeFee() {
    return OnomyHubConstants.UNKNOWN_BALANCE;
  }
  onFromBalance(cb, address, fiatCurrency = OnomyHubConstants.DEFAULT_FIAT_CURRENCY) {
    const fromAsset = this.getFromAsset();
    return this.balances.subscribe([fromAsset, address, fiatCurrency], cb);
  }
  onToBalance(cb, address, fiatCurrency = OnomyHubConstants.DEFAULT_FIAT_CURRENCY) {
    const toAsset = this.getToAsset();
    return this.balances.subscribe([toAsset, address, fiatCurrency], cb);
  }
  async validateTxParams(params) {
    const errors = {};
    const [balance, bridgeFee] = await Promise.all([this.getFromBalance(), this.getBridgeFee()]);
    if (params.amount.amount <= 0) {
      errors.amount = "Bridge amount must be greater than 0";
    }
    if (bridgeFee.amount > 0) {
      if (OnomyHubConstants.isAssetEqual(bridgeFee.asset, balance.asset)) {
        if (bridgeFee.amount + params.amount.amount > balance.amount) {
          errors.amount = "Bridge amount with fees exceeds available balance";
        }
      }
    }
    if (params.amount.amount > balance.amount) {
      errors.amount = "Bridge amount exceeds available balance";
    }
    if (!OnomyHubConstants.isAssetEqual(this.getFromAsset(), params.amount)) {
      errors.amount = "Incorrect asset for bridge";
    }
    return Object.values(errors).find((x) => x) ? errors : null;
  }
  async validateApproveParams(params) {
    const errors = {};
    if (params.amount.amount <= 0) {
      errors.amount = "Bridge approve amount must be greater than 0";
    }
    if (!OnomyHubConstants.isAssetEqual(this.getFromAsset(), params.amount)) {
      errors.amount = "Incorrect asset for bridge approve";
    }
    return Object.values(errors).find((x) => x) ? errors : null;
  }
  async getApprovedAmount() {
    return OnomyHubConstants.UNKNOWN_BALANCE;
  }
  onApprovedAmountUpdate(cb) {
    (async () => {
      const val = await this.getApprovedAmount();
      const detailed = await this.balances.includeDetails(val);
      cb(detailed);
    })();
    return () => {
    };
  }
  getRequiresApproval() {
    return false;
  }
  async doApproveImplemetation(_params) {
    if (!this.getRequiresApproval())
      throw new Error("No approval required for this bridge");
    throw new Error("doApprove not implemented");
  }
  async doApprove(params) {
    const approvedBefore = await this.getApprovedAmount();
    const transaction = await this.doApproveImplemetation(params);
    const approvedAfter = await this.getApprovedAmount();
    const [approvedAmount, allowanceBefore, allowanceAfter] = await Promise.all([
      this.balances.includeDetails(params.amount),
      this.balances.includeDetails(approvedBefore),
      this.balances.includeDetails(approvedAfter)
    ]);
    return {
      approvedAmount,
      allowanceBefore,
      allowanceAfter,
      transaction
    };
  }
  async getDestinationAddress({ destination }) {
    if (destination)
      return destination;
    const [dest] = await this.chains.onomy.getAddresses();
    return dest;
  }
  doBridgeProgress(params, txResult, cb) {
    const unsub = this.onToBalance((newBalance) => {
      if (newBalance.amount >= txResult.expectedToBalanceAfterBridge.amount) {
        cb({
          type: "COMPLETE",
          txResult,
          progressUnits: 0,
          totalUnits: 0,
          unitDescription: "",
          description: "Waiting...",
          fromAsset: this.getFromAsset(),
          toAsset: this.getToAsset(),
          params
        });
        unsub();
      } else {
        cb({
          type: "WAITING",
          txResult,
          progressUnits: 0,
          totalUnits: 0,
          unitDescription: "",
          description: "Waiting...",
          fromAsset: this.getFromAsset(),
          toAsset: this.getToAsset(),
          params
        });
      }
    });
  }
  async doBridgeTx(params) {
    const destination = await this.getDestinationAddress(params);
    const [
      [fromBalanceBefore, toBalanceBefore, gasBalanceBefore],
      transaction,
      [fromBalanceAfter, toBalanceAfter, gasBalanceAfter]
    ] = await this.balances.beforeAndAfterMultiple([[this.getFromAsset()], [this.getToAsset(), destination], [OnomyHubConstants.ETH_ASSET]], () => this.doBridgeTxSend(params));
    const toBalanceIncreaseAmount = {
      asset: toBalanceBefore.asset,
      amount: BigInt(params.amount.amount.toString())
    };
    const [
      fromBalanceDecrease,
      toBalanceIncrease,
      gasBalanceDecrease,
      expectedToBalanceAfterBridge
    ] = await Promise.all([
      this.balances.subtract(fromBalanceBefore, fromBalanceAfter),
      this.balances.includeDetails(toBalanceIncreaseAmount),
      this.balances.subtract(gasBalanceBefore, gasBalanceAfter),
      this.balances.add(toBalanceAfter, toBalanceIncreaseAmount)
    ]);
    const gasSpent = OnomyHubConstants.isAssetEqual(fromBalanceBefore.asset, gasBalanceDecrease) ? await this.balances.subtract(fromBalanceDecrease, params.amount) : gasBalanceDecrease;
    return {
      destination,
      fromBalanceBefore,
      toBalanceBefore,
      gasBalanceBefore,
      fromBalanceAfter,
      toBalanceAfter,
      gasBalanceAfter,
      expectedToBalanceAfterBridge,
      fromBalanceDecrease,
      gasSpent,
      toBalanceIncrease,
      transaction
    };
  }
  doBridge(params, cb) {
    const emitter = new TypedEvent();
    let eventCallback = cb;
    function unsub() {
      eventCallback = void 0;
    }
    if (eventCallback) {
      eventCallback({
        type: "TX_PENDING",
        progressUnits: 0,
        totalUnits: 0,
        unitDescription: "",
        description: "Sending transaction",
        fromAsset: this.getFromAsset(),
        toAsset: this.getToAsset(),
        params
      });
    }
    const completionPromise = new Promise((ok, fail) => {
      function statusHandler(status) {
        if (eventCallback)
          eventCallback(status);
        if (status.type === "ERROR") {
          fail(status);
          emitter.off(statusHandler);
        }
        if (status.type === "COMPLETE") {
          ok(status);
          emitter.off(statusHandler);
        }
      }
      emitter.on(statusHandler);
    });
    const txPromise = this.doBridgeTx(params);
    (async () => {
      try {
        const txResult = await txPromise;
        this.doBridgeProgress(params, txResult, emitter.emit.bind(emitter));
      } catch (error) {
        emitter.emit({
          type: "ERROR",
          error,
          progressUnits: 0,
          totalUnits: 0,
          unitDescription: "",
          description: "Bridge TX Failed",
          fromAsset: this.getFromAsset(),
          toAsset: this.getToAsset(),
          params
        });
      }
    })();
    return [txPromise, completionPromise, emitter, unsub];
  }
}

class AbstractGravityBridge extends AbstractAssetBridge {
  constructor(gravityContractAddress, ...params) {
    super(...params);
    this.ethBlockWait = 64;
    this.gravityContract = GravityCont(gravityContractAddress, this.chains.ethereum.signer);
    this.tokenContract = ERC20Cont(this.getFromAsset().id, this.chains.ethereum.signer);
  }
  getGasAsset() {
    return OnomyHubConstants.ETH_ASSET;
  }
  getRequiresApproval() {
    return true;
  }
  onApprovedAmountUpdate(cb) {
    var _a, _b;
    let lastBlock = 0;
    const onBlock = async (bNumber) => {
      if (bNumber < lastBlock)
        return;
      lastBlock = bNumber;
      const rawAmount = await this.getApprovedAmount();
      const detailedAmount = await this.balances.includeDetails(rawAmount);
      cb(detailedAmount);
    };
    (_b = (_a = this.chains.ethereum.signer) == null ? void 0 : _a.provider) == null ? void 0 : _b.on("block", onBlock);
    onBlock(1);
    return () => {
      var _a2, _b2;
      (_b2 = (_a2 = this.chains.ethereum.signer) == null ? void 0 : _a2.provider) == null ? void 0 : _b2.off("block", onBlock);
    };
  }
  async estimateTxGas(params) {
    var _a;
    const { amount } = params;
    const dest = await this.getDestinationAddress(params);
    const bridgeAmountInput = new BigNumber(amount.amount.toString());
    const bridgeAmount = bridgeAmountInput.isNaN() || bridgeAmountInput.lte(0) ? new BigNumber(1) : bridgeAmountInput;
    try {
      const gasFeeRaw = await this.gravityContract.estimateGas.sendToCosmos(this.getFromAsset().id, (_a = dest == null ? void 0 : dest.id) != null ? _a : "", bridgeAmount.toFixed(0));
      return gasFeeRaw.toString();
    } catch (e) {
      console.error("e", e);
      if ("code" in e && e.code === "UNPREDICTABLE_GAS_LIMIT") {
        return "100000";
      }
      throw e;
    }
  }
  async estimateApproveGas(params) {
    const { amount } = params;
    try {
      const gasFeeRaw = await this.tokenContract.estimateGas.increaseAllowance(this.gravityContract.address, amount.amount ? amount.amount.toString() : "1");
      const res = gasFeeRaw.toString();
      return res;
    } catch (e) {
      if ("code" in e && e.code === "UNPREDICTABLE_GAS_LIMIT") {
        return "100000";
      }
      throw e;
    }
  }
  async getApprovedAmount() {
    const [ethAddress] = await this.chains.ethereum.getAddresses();
    const allowanceBigInt = await this.tokenContract.allowance(ethAddress.id, this.gravityContract.address);
    return {
      asset: this.getFromAsset(),
      amount: BigInt(allowanceBigInt.toString())
    };
  }
  async doApproveImplemetation(params) {
    var _a, _b;
    const { amount, gasPrice } = params;
    console.log("gasPrice", gasPrice);
    const tx = await this.tokenContract.increaseAllowance(this.gravityContract.address, amount.amount.toString(), {
      gasPrice
    });
    const receipt = await tx.wait();
    return {
      hash: tx.hash,
      block: {
        chain: OnomyHubConstants.ETH_CHAIN,
        height: BigInt((_a = receipt.blockNumber) != null ? _a : 0),
        hash: (_b = receipt.blockHash) != null ? _b : ""
      }
    };
  }
  async doBridgeTxSend(params) {
    var _a, _b;
    const { amount, gasPrice } = params;
    const dest = await this.getDestinationAddress(params);
    const tx = await this.gravityContract.sendToCosmos(this.getFromAsset().id, dest.id, amount.amount.toString(), { gasPrice });
    const receipt = await tx.wait();
    return {
      hash: tx.hash,
      block: {
        chain: OnomyHubConstants.ETH_CHAIN,
        height: BigInt((_a = receipt.blockNumber) != null ? _a : 0),
        hash: (_b = receipt.blockHash) != null ? _b : ""
      }
    };
  }
  doBridgeProgress(params, txResult, cb) {
    const ethProvider = this.chains.ethereum.signer.provider;
    const startBlockNumber = parseInt(txResult.transaction.block.height.toString(), 10);
    const blocksToWait = this.ethBlockWait;
    let lastBlock = startBlockNumber;
    const onBlock = (bNumber) => {
      if (bNumber <= lastBlock)
        return;
      lastBlock = bNumber;
      const elapsed = bNumber - startBlockNumber;
      if (elapsed >= blocksToWait) {
        cb({
          type: "WAITING",
          txResult,
          progressUnits: blocksToWait,
          totalUnits: blocksToWait,
          unitDescription: "blocks",
          description: `Waiting for validation`,
          fromAsset: this.getFromAsset(),
          toAsset: this.getToAsset(),
          params
        });
      } else {
        cb({
          type: "INPROGRESS",
          txResult,
          progressUnits: elapsed,
          totalUnits: blocksToWait,
          unitDescription: "blocks",
          description: `${elapsed}/${blocksToWait} - 96 ETH blocks remain`,
          fromAsset: this.getFromAsset(),
          toAsset: this.getToAsset(),
          params
        });
      }
    };
    ethProvider == null ? void 0 : ethProvider.on("block", onBlock);
    this.onToBalance((newBalance) => {
      if (newBalance.amount >= txResult.expectedToBalanceAfterBridge.amount) {
        ethProvider == null ? void 0 : ethProvider.off("block", onBlock);
        cb({
          type: "COMPLETE",
          txResult,
          progressUnits: blocksToWait,
          totalUnits: blocksToWait,
          unitDescription: "blocks",
          description: `Bridge successful`,
          fromAsset: this.getFromAsset(),
          toAsset: this.getToAsset(),
          params
        });
      }
    }, txResult.destination);
  }
}

class BridgeBNomToNom extends AbstractGravityBridge {
  getFromAsset() {
    return OnomyHubConstants.BNOM_ASSET;
  }
  getToAsset() {
    return OnomyHubConstants.NOM_ASSET;
  }
}

class OnomyHubError extends Error {
}
class AssetMismatch extends OnomyHubError {
  constructor(message = "Asset Mismatch") {
    super(message);
  }
}
class NotImplemented extends OnomyHubError {
  constructor(message = "Not Implemented") {
    super(message);
  }
}
class UnsupportedChain extends OnomyHubError {
  constructor(name = "unknown") {
    super(`Unsupported Blockchain: ${name}`);
  }
}
class UnsupportedStakingChain extends OnomyHubError {
  constructor(message = "Only NOM can be staked") {
    super(message);
  }
}
class InvalidParams extends OnomyHubError {
  constructor(message = "Invalid Parameters") {
    super(message);
  }
}
const OnomyHubErrors = {
  OnomyHubError,
  AssetMismatch,
  NotImplemented,
  UnsupportedChain,
  UnsupportedStakingChain,
  InvalidParams
};

async function getSupportedAssets() {
  return OnomyHubConstants.SUPPORTED_ASSETS;
}
async function getAssetMeta(asset) {
  var _a, _b;
  const assets = await OnomyHubUtils.getSupportedAssets();
  const assetStr = `${asset.chain.name}:${asset.id}`;
  const knownAsset = assets.find((a) => `${a.chain.name}:${a.id}` === assetStr);
  return (_b = (_a = knownAsset == null ? void 0 : knownAsset.meta) != null ? _a : asset.meta) != null ? _b : OnomyHubConstants.UNKNOWN_ASSET_META;
}
function combineBalances(balances) {
  const grouped = groupBy((balance) => {
    return [balance.asset.chain.name, balance.asset.id].join("-");
  }, balances);
  return Object.values(grouped).map((items) => items.reduce((res, item) => {
    return {
      ...res,
      amount: res.amount + item.amount
    };
  }, {
    asset: items[0].asset,
    amount: BigInt(0)
  }));
}
function combinedFiatValue(balances) {
  return balances.reduce((total, x) => total + x.fiatValue, 0);
}
function normalizeBigNum(bigNum) {
  return new BigNumber(bigNum.toString());
}
const OnomyHubUtils = {
  normalizeBigNum,
  getSupportedAssets,
  getAssetMeta,
  combineBalances,
  combinedFiatValue
};

class OnomyDetailedBalances {
  constructor(balances, prices) {
    this.balances = balances;
    this.prices = prices;
  }
  async all(fiatCurrency = OnomyHubConstants.DEFAULT_FIAT_CURRENCY) {
    const assets = await OnomyHubUtils.getSupportedAssets();
    return Promise.all(assets.map((asset) => this.get(asset, void 0, fiatCurrency)));
  }
  subscribeMultiple(items, cb, fiatCurrency = OnomyHubConstants.DEFAULT_FIAT_CURRENCY) {
    const handler = async () => {
      cb(await this.getMultiple(items, fiatCurrency));
    };
    const unsubFns = items.map(([asset, address]) => this.subscribe([asset, address, fiatCurrency], handler));
    return () => {
      unsubFns.forEach((fn) => fn());
    };
  }
  async beforeAndAfter(asset, fn, address, fiatCurrency = OnomyHubConstants.DEFAULT_FIAT_CURRENCY) {
    const before = await this.forceGet(asset, address, fiatCurrency);
    const res = await fn();
    const after = await this.forceGet(asset, address, fiatCurrency);
    return [before, res, after];
  }
  async beforeAndAfterMultiple(items, fn, fiatCurrency = OnomyHubConstants.DEFAULT_FIAT_CURRENCY) {
    const before = await this.forceGetMultiple(items, fiatCurrency);
    const res = await fn();
    const after = await this.forceGetMultiple(items, fiatCurrency);
    return [before, res, after];
  }
  async includeDetails(balance, fiatCurrency = OnomyHubConstants.DEFAULT_FIAT_CURRENCY) {
    const { asset, amount } = balance;
    return this.fromAmount(asset, amount.toString(), fiatCurrency);
  }
  async includeDetailsMultiple(balances, fiatCurrency = OnomyHubConstants.DEFAULT_FIAT_CURRENCY) {
    return Promise.all(balances.map((balance) => this.includeDetails(balance, fiatCurrency)));
  }
  async fromAmount(asset, amountFixedStr, fiatCurrency = OnomyHubConstants.DEFAULT_FIAT_CURRENCY) {
    const [meta, fiatPrice] = await Promise.all([
      OnomyHubUtils.getAssetMeta(asset),
      this.prices.get(asset, fiatCurrency)
    ]);
    const bnAmountFixed = new BigNumber(amountFixedStr);
    const bnAmountShifted = bnAmountFixed.shiftedBy(-1 * meta.decimalPlaces);
    const fiatValue = bnAmountShifted.times(fiatPrice).toNumber();
    const amountFormatted = bnAmountShifted.toFixed();
    return {
      asset: {
        ...asset,
        meta
      },
      amount: BigInt(amountFixedStr),
      fiatPrice,
      fiatCurrency,
      fiatValue,
      amountFormatted
    };
  }
  async get(asset, address, fiatCurrency = OnomyHubConstants.DEFAULT_FIAT_CURRENCY) {
    const amountFixedStr = await this.balances.get(asset, address);
    return this.fromAmount(asset, amountFixedStr, fiatCurrency);
  }
  async getMultiple(items, fiatCurrency = OnomyHubConstants.DEFAULT_FIAT_CURRENCY) {
    return Promise.all(items.map(([asset, address]) => this.get(asset, address, fiatCurrency)));
  }
  async forceGetMultiple(items, fiatCurrency = OnomyHubConstants.DEFAULT_FIAT_CURRENCY) {
    return Promise.all(items.map(([asset, address]) => this.forceGet(asset, address, fiatCurrency)));
  }
  async forceGet(asset, address, fiatCurrency = OnomyHubConstants.DEFAULT_FIAT_CURRENCY) {
    this.balances.clear(asset, address);
    return this.get(asset, address, fiatCurrency);
  }
  async add(to, amount, fiatCurrency = OnomyHubConstants.DEFAULT_FIAT_CURRENCY) {
    if (!OnomyHubConstants.isAssetEqual(to.asset, amount.asset)) {
      throw new OnomyHubErrors.AssetMismatch();
    }
    const result = {
      asset: to.asset,
      amount: to.amount + amount.amount
    };
    return this.includeDetails(result, fiatCurrency);
  }
  async subtract(from, amount, fiatCurrency = OnomyHubConstants.DEFAULT_FIAT_CURRENCY) {
    if (!OnomyHubConstants.isAssetEqual(from.asset, amount.asset)) {
      throw new OnomyHubErrors.AssetMismatch();
    }
    const result = {
      asset: from.asset,
      amount: from.amount - amount.amount
    };
    return this.includeDetails(result, fiatCurrency);
  }
  subscribe([asset, address, fiatCurrency = OnomyHubConstants.DEFAULT_FIAT_CURRENCY], cb) {
    const handler = async () => cb(await this.get(asset, address, fiatCurrency));
    const unsubPrice = this.prices.subscribe([asset, fiatCurrency], handler);
    const unsubBalance = this.balances.subscribe([asset, address], handler);
    return () => {
      unsubPrice();
      unsubBalance();
    };
  }
}

async function getPoolState(poolContract) {
  const [liquidity, slot] = await Promise.all([poolContract.liquidity(), poolContract.slot0()]);
  const PoolState = {
    liquidity,
    sqrtPriceX96: slot[0],
    tick: slot[1],
    observationIndex: slot[2],
    observationCardinality: slot[3],
    observationCardinalityNext: slot[4],
    feeProtocol: slot[5],
    unlocked: slot[6]
  };
  return PoolState;
}
async function getPoolImmutables(poolContract) {
  const [factory, token0, token1, fee, tickSpacing, maxLiquidityPerTick] = await Promise.all([
    poolContract.factory(),
    poolContract.token0(),
    poolContract.token1(),
    poolContract.fee(),
    poolContract.tickSpacing(),
    poolContract.maxLiquidityPerTick()
  ]);
  const immutables = {
    factory,
    token0,
    token1,
    fee,
    tickSpacing,
    maxLiquidityPerTick
  };
  return immutables;
}
async function fetchPool(poolContract, immutables) {
  const [state] = await Promise.all([OnomyUniswapClient.getPoolState(poolContract)]);
  const TokenA = new Token(3, immutables.token1, 6, "USDT", "Tether USD");
  const TokenB = new Token(3, immutables.token0, 18, "WETH", "Wrapped Ether");
  const poolExample = new Pool(TokenA, TokenB, immutables.fee, state.sqrtPriceX96.toString(), state.liquidity.toString(), state.tick);
  return poolExample;
}
async function init$k(chains, wEthUsdtPoolAddress = "") {
  const { provider } = chains.ethereum.signer;
  try {
    if (provider && wEthUsdtPoolAddress) {
      const wEthUsdtPoolContract = new ethers.Contract(wEthUsdtPoolAddress, abi$3, provider);
      const immutables = await OnomyUniswapClient.getPoolImmutables(wEthUsdtPoolContract);
      return {
        async fetchEthUsdtPrice() {
          const pool = await OnomyUniswapClient.fetchPool(wEthUsdtPoolContract, immutables);
          const price = pool.token0Price;
          return price.toFixed();
        }
      };
    }
  } catch (e) {
    console.error("Error getting eth price from uniswap", e);
  }
  return {
    async fetchEthUsdtPrice() {
      return "1300.00";
    }
  };
}
const OnomyUniswapClient = {
  init: init$k,
  getPoolState,
  getPoolImmutables,
  fetchPool
};

class AbstractThrottledAsyncCache extends InheritableEventEmitter {
  constructor() {
    super();
    this.cacheDuration = 6e4;
    this.pollInterval = 3e4;
    this.intervals = {};
    this.cache = new ExpiryMap(this.cacheDuration);
    this.throttledFn = pMemoize(this.callFn.bind(this), {
      cache: this.cache,
      cacheKey: this.cacheKey.bind(this)
    });
    this.get = this.get.bind(this);
  }
  get(...args) {
    return this.throttledFn(...args);
  }
  getMultiple(items) {
    return Promise.all(items.map((args) => this.get(...args)));
  }
  forceGet(...args) {
    this.clear(...args);
    return this.get(...args);
  }
  clear(...args) {
    const key = this.cacheKey(args);
    this.cache.delete(key);
  }
  subscribe(args, fn) {
    const key = this.cacheKey(args);
    const handler = (evtArgs, evtVal) => {
      const evtKey = this.cacheKey(evtArgs);
      if (evtKey === key)
        fn(evtVal);
    };
    this.on("updated", handler);
    let intervalState = this.intervals[key];
    if (intervalState) {
      intervalState.subscribers += 1;
    } else {
      intervalState = {
        subscribers: 1,
        interval: setInterval(() => this.get(...args), this.pollInterval)
      };
      this.intervals[key] = intervalState;
    }
    (async () => {
      const val = await this.get(...args);
      handler(args, val);
    })();
    let unsubbed = false;
    return () => {
      if (unsubbed)
        return;
      this.off("updated", handler);
      unsubbed = true;
      const iState = this.intervals[key];
      if (!iState)
        return;
      iState.subscribers -= 1;
      if (iState.subscribers <= 0) {
        clearTimeout(iState.interval);
        this.intervals[key] = void 0;
      }
    };
  }
  subscribeMultiple(items, cb) {
    const handler = async () => {
      cb(await this.getMultiple(items));
    };
    const unsubFns = items.map((args) => this.subscribe(args, handler));
    handler();
    return () => {
      unsubFns.forEach((fn) => fn());
    };
  }
  implementation(..._args) {
    throw new OnomyHubErrors.NotImplemented();
  }
  cacheKey(_args) {
    throw new OnomyHubErrors.NotImplemented();
  }
  async callFn(...args) {
    const res = await this.implementation(...args);
    this.emit("updated", args, res);
    return res;
  }
}

class OnomyAssetPrices extends AbstractThrottledAsyncCache {
  constructor(chains, bc, wEthUsdtUniswapPoolAddress = "") {
    super();
    this.uniswap = null;
    this.chains = chains;
    this.bc = bc;
    this.wEthUsdtUniswapPoolAddress = wEthUsdtUniswapPoolAddress;
  }
  cacheKey([asset, fiatCurrency = OnomyHubConstants.DEFAULT_FIAT_CURRENCY]) {
    return [asset.chain.name, asset.id, fiatCurrency].join("|");
  }
  async implementation(asset, fiatCurrency = OnomyHubConstants.DEFAULT_FIAT_CURRENCY) {
    if (OnomyHubConstants.isAssetETH(asset)) {
      const uniswap = await this.getUniswap();
      const priceStr = await uniswap.fetchEthUsdtPrice();
      const result = parseFloat(priceStr);
      return result;
    }
    if (OnomyHubConstants.isAssetBNOM(asset)) {
      const [ethFiatPrice, bcState] = await Promise.all([
        this.get(OnomyHubConstants.ETH_ASSET, fiatCurrency),
        this.bc.getState()
      ]);
      const nomEthPrice = new BigNumber(1).dividedBy(bcState.currentETHPrice.shiftedBy(-18));
      const result = nomEthPrice.times(ethFiatPrice).toNumber();
      return result;
    }
    if (OnomyHubConstants.isAssetNOM(asset) || OnomyHubConstants.isAssetEthNom(asset)) {
      return this.get(OnomyHubConstants.BNOM_ASSET, fiatCurrency);
    }
    return 0;
  }
  async getUniswap() {
    if (this.uniswap)
      return this.uniswap;
    this.uniswap = OnomyUniswapClient.init(this.chains, this.wEthUsdtUniswapPoolAddress);
    return this.uniswap;
  }
}

class OnomyAssetBalances extends AbstractThrottledAsyncCache {
  constructor(chains) {
    super();
    this.chains = chains;
  }
  cacheKey([asset, address]) {
    var _a, _b;
    return [asset.chain.name, asset.id, (_a = address == null ? void 0 : address.chain.name) != null ? _a : "", (_b = address == null ? void 0 : address.id) != null ? _b : ""].join("|");
  }
  async implementation(asset, address) {
    const params = { asset, address };
    const {
      chain: { name: chainName }
    } = asset;
    switch (chainName) {
      case OnomyHubConstants.ONOMY_CHAIN_ID:
        return this.chains.onomy.getBalance(params);
      case OnomyHubConstants.ETH_CHAIN_ID:
        return this.chains.ethereum.getBalance(params);
      default:
        throw new OnomyHubErrors.UnsupportedChain(chainName);
    }
  }
}

class OnomyDelegations extends AbstractThrottledAsyncCache {
  constructor(chains, balances) {
    super();
    this.chains = chains;
    this.balances = balances;
  }
  async all(fiatCurrency = OnomyHubConstants.DEFAULT_FIAT_CURRENCY) {
    const delegations = await this.chains.onomy.getDelegations();
    return Promise.all(delegations.map((delegation) => this.includeDelegationDetails(delegation, fiatCurrency)));
  }
  cacheKey([address, fiatCurrency = OnomyHubConstants.DEFAULT_FIAT_CURRENCY]) {
    return [address.chain.name, address.id, fiatCurrency].join("|");
  }
  async includeValidatorDetails(validator, fiatCurrency = OnomyHubConstants.DEFAULT_FIAT_CURRENCY) {
    const [staked, selfStaked] = await Promise.all([
      this.balances.includeDetails(validator.staked, fiatCurrency),
      this.balances.includeDetails(validator.selfStaked, fiatCurrency)
    ]);
    return {
      ...validator,
      staked,
      selfStaked,
      symbol: "onomy"
    };
  }
  async includeDelegationDetails(delegation, fiatCurrency = OnomyHubConstants.DEFAULT_FIAT_CURRENCY) {
    const [validator, delegated, reward, unbonding] = await Promise.all([
      this.includeValidatorDetails(delegation.validator, fiatCurrency),
      this.balances.includeDetails(delegation.delegated, fiatCurrency),
      this.balances.includeDetails(delegation.reward, fiatCurrency),
      this.balances.includeDetails(delegation.unbonding, fiatCurrency)
    ]);
    return {
      ...delegation,
      validator,
      delegated,
      reward,
      unbonding
    };
  }
  async implementation(address, fiatCurrency = OnomyHubConstants.DEFAULT_FIAT_CURRENCY) {
    const delegation = await this.chains.onomy.getDelegation(address);
    if (!delegation)
      return null;
    return this.includeDelegationDetails(delegation, fiatCurrency);
  }
}

async function getAssetAddress(chains, assetOrChain) {
  const chainName = "chain" in assetOrChain ? assetOrChain.chain.name : assetOrChain.name;
  switch (chainName) {
    case OnomyHubConstants.ONOMY_CHAIN.name:
      const [onomyAddress] = await chains.onomy.getAddresses();
      return onomyAddress;
    default:
      const [ethAddress] = await chains.ethereum.getAddresses();
      return ethAddress;
  }
}
async function suggestGasPrices$2(chains, params) {
  const {
    asset: {
      chain: { name: chainName }
    }
  } = params;
  switch (chainName) {
    case OnomyHubConstants.ONOMY_CHAIN_ID:
      return chains.onomy.suggestGasPrices(params);
    case OnomyHubConstants.ETH_CHAIN_ID:
      return chains.ethereum.suggestGasPrices(params);
    default:
      throw new OnomyHubErrors.UnsupportedChain(chainName);
  }
}
function isAddressValid$2(chains, address) {
  const {
    chain: { name: chainName }
  } = address;
  switch (chainName) {
    case OnomyHubConstants.ONOMY_CHAIN_ID:
      return chains.onomy.isAddressValid(address);
    case OnomyHubConstants.ETH_CHAIN_ID:
      return chains.ethereum.isAddressValid(address);
    default:
      throw new OnomyHubErrors.UnsupportedChain(chainName);
  }
}
const OnomyHubChains = {
  getAssetAddress,
  suggestGasPrices: suggestGasPrices$2,
  isAddressValid: isAddressValid$2
};

function getParamsErrors$6(chains, params, assetBalanceFixed = "0") {
  const errors = {};
  if (params.asset.chain.name !== OnomyHubConstants.ONOMY_CHAIN.name || params.asset.id !== OnomyHubConstants.NOM_ASSET.id) {
    errors.asset = "Asset must be NOM";
  }
  const { validatorAddress, amountFixed } = params;
  if (!validatorAddress) {
    errors.validatorAddress = "Required";
  } else if (params.asset) {
    if (!OnomyHubChains.isAddressValid(chains, {
      chain: params.asset.chain,
      id: params.validatorAddress
    })) {
      errors.validatorAddress = "Invalid Address";
    }
  }
  const amount = new BigNumber(amountFixed || "0");
  if (amount.gt(assetBalanceFixed))
    errors.amountFixed = "Insufficient balance";
  if (amount.isNaN())
    errors.amountFixed = "Invalid amount";
  if (amount.lte(0))
    errors.amountFixed = "Must be > 0";
  return Object.values(errors).find((x) => x) ? errors : null;
}
async function estimateGas$e(chains, params) {
  switch (params.asset.chain.name) {
    case OnomyHubConstants.ONOMY_CHAIN.name:
      return chains.onomy.DelegateAsset.estimateGas(params);
    default:
      throw new OnomyHubErrors.UnsupportedStakingChain();
  }
}
async function calculateMax$7(chains, params) {
  switch (params.asset.chain.name) {
    case OnomyHubConstants.ONOMY_CHAIN.name:
      return chains.onomy.DelegateAsset.calculateMax(params);
    default:
      throw new OnomyHubErrors.UnsupportedStakingChain();
  }
}
async function execute$e(chains, balances, delegations, params, assetBalanceFixed = "0") {
  const paramsErrors = DelegateAsset.getParamsErrors(chains, params, assetBalanceFixed);
  if (paramsErrors) {
    console.error("params errors", paramsErrors);
    throw new OnomyHubErrors.InvalidParams();
  }
  const validatorAddress = {
    chain: params.asset.chain,
    id: params.validatorAddress
  };
  const delegationBefore = delegations.forceGet(validatorAddress);
  const [balanceBefore, res, balanceAfter] = await balances.beforeAndAfter(params.asset, async () => {
    switch (params.asset.chain.name) {
      case OnomyHubConstants.ONOMY_CHAIN.name:
        return chains.onomy.DelegateAsset.execute(params);
      default:
        throw new OnomyHubErrors.UnsupportedStakingChain();
    }
  });
  const delegationAmount = await balances.includeDetails({
    asset: balanceBefore.asset,
    amount: BigInt(params.amountFixed)
  });
  const delegationAfter = delegations.forceGet(validatorAddress);
  return {
    ...res,
    delegationAmount,
    delegationBefore,
    delegationAfter,
    balanceBefore,
    balanceAfter
  };
}
function init$j(chains, balances, delegations) {
  return {
    execute(params, assetBalanceFixed = "0") {
      return DelegateAsset.execute(chains, balances, delegations, params, assetBalanceFixed);
    },
    getParamsErrors(params, assetBalanceFixed = "0") {
      return DelegateAsset.getParamsErrors(chains, params, assetBalanceFixed);
    },
    estimateGas(params) {
      return DelegateAsset.estimateGas(chains, params);
    },
    calculateMax(params) {
      return DelegateAsset.calculateMax(chains, params);
    }
  };
}
const DelegateAsset = {
  init: init$j,
  execute: execute$e,
  getParamsErrors: getParamsErrors$6,
  estimateGas: estimateGas$e,
  calculateMax: calculateMax$7
};

function getParamsErrors$5(chains, params, delegatedAmountFixed = "0") {
  const errors = {};
  if (params.asset.chain.name !== OnomyHubConstants.ONOMY_CHAIN.name || params.asset.id !== OnomyHubConstants.NOM_ASSET.id) {
    errors.asset = "Asset must be NOM";
  }
  const { validatorAddress, amountFixed } = params;
  if (!validatorAddress) {
    errors.validatorAddress = "Required";
  } else if (params.asset) {
    if (!OnomyHubChains.isAddressValid(chains, {
      chain: params.asset.chain,
      id: params.validatorAddress
    })) {
      errors.validatorAddress = "Invalid Address";
    }
  }
  const amount = new BigNumber(amountFixed || "0");
  if (amount.gt(delegatedAmountFixed))
    errors.amountFixed = "Exceeds delegated amount";
  if (amount.isNaN())
    errors.amountFixed = "Invalid amount";
  if (amount.lte(0))
    errors.amountFixed = "Must be > 0";
  return Object.values(errors).find((x) => x) ? errors : null;
}
async function estimateGas$d(chains, params) {
  switch (params.asset.chain.name) {
    case OnomyHubConstants.ONOMY_CHAIN.name:
      return chains.onomy.UndelegateAsset.estimateGas(params);
    default:
      throw new OnomyHubErrors.UnsupportedStakingChain();
  }
}
async function execute$d(chains, balances, delegations, params, delegatedAmountFixed = "0") {
  const paramsErrors = UndelegateAsset.getParamsErrors(chains, params, delegatedAmountFixed);
  if (paramsErrors) {
    console.error("params errors", paramsErrors);
    throw new OnomyHubErrors.InvalidParams();
  }
  const validatorAddress = {
    chain: params.asset.chain,
    id: params.validatorAddress
  };
  const delegationBefore = delegations.forceGet(validatorAddress);
  const [balanceBefore, res, balanceAfter] = await balances.beforeAndAfter(params.asset, async () => {
    switch (params.asset.chain.name) {
      case OnomyHubConstants.ONOMY_CHAIN.name:
        return chains.onomy.UndelegateAsset.execute(params);
      default:
        throw new OnomyHubErrors.UnsupportedStakingChain();
    }
  });
  const delegationAmount = await balances.includeDetails({
    asset: balanceBefore.asset,
    amount: BigInt(params.amountFixed)
  });
  const delegationAfter = delegations.forceGet(validatorAddress);
  return {
    ...res,
    delegationAmount,
    delegationBefore,
    delegationAfter,
    balanceBefore,
    balanceAfter
  };
}
function init$i(chains, balances, delegations) {
  return {
    execute(params, delegatedAmountFixed = "0") {
      return UndelegateAsset.execute(chains, balances, delegations, params, delegatedAmountFixed);
    },
    getParamsErrors(params, delegatedAmountFixed = "0") {
      return UndelegateAsset.getParamsErrors(chains, params, delegatedAmountFixed);
    },
    estimateGas(params) {
      return UndelegateAsset.estimateGas(chains, params);
    }
  };
}
const UndelegateAsset = {
  init: init$i,
  execute: execute$d,
  getParamsErrors: getParamsErrors$5,
  estimateGas: estimateGas$d
};

function getParamsErrors$4(chains, params) {
  const errors = {};
  const amount = new BigNumber(params.amountFixed || "0");
  if (!params.asset)
    errors.asset = "Required";
  if (!params.destAddress) {
    errors.destAddress = "Required";
  } else if (params.asset) {
    if (!OnomyHubChains.isAddressValid(chains, {
      chain: params.asset.chain,
      id: params.destAddress
    })) {
      errors.destAddress = "Invalid Address";
    }
  }
  if (amount.lte(0))
    errors.amountFixed = "Must be > 0";
  return Object.values(errors).find((x) => x) ? errors : null;
}
async function getGasAsset(params) {
  var _a;
  switch ((_a = params.asset) == null ? void 0 : _a.chain.name) {
    case OnomyHubConstants.ONOMY_CHAIN.name:
      return OnomyHubConstants.NOM_ASSET;
    case OnomyHubConstants.ETH_CHAIN.name:
      return OnomyHubConstants.ETH_ASSET;
    default:
      return null;
  }
}
async function estimateGas$c(chains, params) {
  var _a;
  switch ((_a = params.asset) == null ? void 0 : _a.chain.name) {
    case OnomyHubConstants.ETH_CHAIN.name:
      return chains.ethereum.TransferAsset.estimateGas(params);
    case OnomyHubConstants.ONOMY_CHAIN.name:
      return chains.onomy.TransferAsset.estimateGas(params);
    default:
      throw new OnomyHubErrors.UnsupportedChain();
  }
}
async function execute$c(chains, balances, params) {
  if (TransferAsset.getParamsErrors(chains, params) || !params.asset) {
    throw new OnomyHubErrors.InvalidParams();
  }
  const [beforeBalance, transaction, afterBalance] = await balances.beforeAndAfter(params.asset, async () => {
    var _a;
    switch ((_a = params.asset) == null ? void 0 : _a.chain.name) {
      case OnomyHubConstants.ONOMY_CHAIN.name:
        return chains.onomy.TransferAsset.execute(params);
      case OnomyHubConstants.ETH_CHAIN.name:
        return chains.ethereum.TransferAsset.execute(params);
      default:
        throw new OnomyHubErrors.UnsupportedChain();
    }
  });
  return {
    asset: params.asset,
    transaction,
    beforeBalance,
    afterBalance
  };
}
async function calculateMax$6(chains, params) {
  var _a;
  switch ((_a = params.asset) == null ? void 0 : _a.chain.name) {
    case OnomyHubConstants.ONOMY_CHAIN.name:
      return chains.onomy.TransferAsset.calculateMax(params);
    case OnomyHubConstants.ETH_CHAIN.name:
      return chains.ethereum.TransferAsset.calculateMax(params);
    default:
      throw new OnomyHubErrors.UnsupportedChain();
  }
}
function init$h(chains, balances) {
  return {
    execute(params) {
      return TransferAsset.execute(chains, balances, params);
    },
    getGasAsset,
    calculateMax(params) {
      return TransferAsset.calculateMax(chains, params);
    },
    getParamsErrors(params) {
      return TransferAsset.getParamsErrors(chains, params);
    },
    estimateGas(params) {
      return TransferAsset.estimateGas(chains, params);
    }
  };
}
const TransferAsset = {
  init: init$h,
  execute: execute$c,
  getParamsErrors: getParamsErrors$4,
  getGasAsset,
  estimateGas: estimateGas$c,
  calculateMax: calculateMax$6
};

function getParamsErrors$3(chains, params) {
  const errors = {};
  if (params.asset.chain.name !== OnomyHubConstants.ONOMY_CHAIN.name || params.asset.id !== OnomyHubConstants.NOM_ASSET.id) {
    errors.asset = "Asset must be NOM";
  }
  const { validatorAddress } = params;
  if (!validatorAddress) {
    errors.validatorAddress = "Required";
  } else if (params.asset) {
    if (!OnomyHubChains.isAddressValid(chains, {
      chain: params.asset.chain,
      id: params.validatorAddress
    })) {
      errors.validatorAddress = "Invalid Address";
    }
  }
  return Object.values(errors).find((x) => x) ? errors : null;
}
async function estimateGas$b(chains, params) {
  switch (params.asset.chain.name) {
    case OnomyHubConstants.ONOMY_CHAIN.name:
      return chains.onomy.ClaimReward.estimateGas(params);
    default:
      throw new OnomyHubErrors.UnsupportedStakingChain();
  }
}
async function execute$b(chains, balances, delegations, params) {
  if (ClaimReward.getParamsErrors(chains, params))
    throw new OnomyHubErrors.InvalidParams();
  const validatorAddress = {
    chain: params.asset.chain,
    id: params.validatorAddress
  };
  const delegationBefore = delegations.forceGet(validatorAddress);
  const [balanceBefore, tx, balanceAfter] = await balances.beforeAndAfter(params.asset, async () => {
    switch (params.asset.chain.name) {
      case OnomyHubConstants.ONOMY_CHAIN.name:
        return chains.onomy.ClaimReward.execute(params);
      default:
        throw new OnomyHubErrors.UnsupportedStakingChain();
    }
  });
  const delegationAfter = delegations.forceGet(validatorAddress);
  return {
    delegationBefore,
    delegationAfter,
    balanceBefore,
    balanceAfter,
    tx
  };
}
function init$g(chains, balances, delegations) {
  return {
    execute(params) {
      return ClaimReward.execute(chains, balances, delegations, params);
    },
    getParamsErrors(params) {
      return ClaimReward.getParamsErrors(chains, params);
    },
    estimateGas(params) {
      return ClaimReward.estimateGas(chains, params);
    }
  };
}
const ClaimReward = {
  init: init$g,
  execute: execute$b,
  getParamsErrors: getParamsErrors$3,
  estimateGas: estimateGas$b
};

async function estimateGas$a(chains, params) {
  switch (params.asset.chain.name) {
    case OnomyHubConstants.ONOMY_CHAIN.name:
      return chains.onomy.RedelegateAsset.estimateGas(params);
    default:
      throw new OnomyHubErrors.UnsupportedStakingChain();
  }
}
async function execute$a(chains, balances, delegations, params) {
  if (RedelegateAsset.getParamsErrors(chains, params))
    throw new OnomyHubErrors.InvalidParams();
  const validatorAddress = {
    chain: params.asset.chain,
    id: params.validatorAddress
  };
  const delegationBefore = delegations.forceGet(validatorAddress);
  const [balanceBefore, tx, balanceAfter] = await balances.beforeAndAfter(params.asset, async () => {
    switch (params.asset.chain.name) {
      case OnomyHubConstants.ONOMY_CHAIN.name:
        return chains.onomy.RedelegateAsset.execute(params);
      default:
        throw new OnomyHubErrors.UnsupportedStakingChain();
    }
  });
  const delegationAfter = delegations.forceGet(validatorAddress);
  return {
    delegationBefore,
    delegationAfter,
    balanceBefore,
    balanceAfter,
    tx
  };
}
function init$f(chains, balances, delegations) {
  return {
    execute(params) {
      return RedelegateAsset.execute(chains, balances, delegations, params);
    },
    getParamsErrors(params) {
      return RedelegateAsset.getParamsErrors(chains, params);
    },
    estimateGas(params) {
      return RedelegateAsset.estimateGas(chains, params);
    }
  };
}
const RedelegateAsset = {
  init: init$f,
  execute: execute$a,
  getParamsErrors: ClaimReward.getParamsErrors,
  estimateGas: estimateGas$a
};

function requireNom(asset, msg = "Only NOM can be staked") {
  if (!asset || `${asset.chain.name}:${asset.id}` !== `${OnomyHubConstants.ONOMY_CHAIN.name}:${OnomyHubConstants.NOM_ASSET.id}`) {
    throw new Error(msg);
  }
}
async function txResToBlockchainTransaction(client, tx) {
  const block = await client.getBlockAtHeight(tx.height);
  return {
    hash: tx.transactionHash,
    block: {
      chain: OnomyHubConstants.ONOMY_CHAIN,
      height: BigInt(tx.height),
      hash: block.id
    }
  };
}
async function getRewardsForValidator(client, validatorAddress) {
  var _a;
  const address = await client.getAddress();
  const rewardsData = await client.getRewardsForDelegator(address);
  const rewardItems = rewardsData == null ? void 0 : rewardsData.rewards.find((v) => v.validatorAddress === validatorAddress);
  const rewardItem = rewardItems == null ? void 0 : rewardItems.reward.find((r) => r.denom === OnomyHubConstants.NOM_ASSET.id);
  return new BigNumber((_a = rewardItem == null ? void 0 : rewardItem.amount) != null ? _a : "0").shiftedBy(-18).toFixed(0);
}
async function suggestGasPrices$1(_params) {
  return ["2", "1.7", "1.3"];
}
function isAddressValid$1(address) {
  try {
    const { data } = Bech32.decode(address.id);
    return data.length === 20;
  } catch (e) {
    return false;
  }
}
function validatorRecordToData(record) {
  if (!record)
    throw new Error("No validator record");
  return {
    description: record.validator.name,
    website: record.validator.website,
    details: record.validator.details,
    securityContact: record.validator.securityContact,
    logoUrl: "",
    estimatedAPR: record.rewards.APR,
    commissionRate: record.rewards.commissionRate,
    selfStakedRatio: record.selfStakeRatio,
    uptimeRatio: 0.99,
    pubKey: record.id,
    isActive: record.validator.isActive,
    address: {
      chain: OnomyHubConstants.ONOMY_CHAIN,
      id: record.id
    },
    delegator: {
      chain: OnomyHubConstants.ONOMY_CHAIN,
      id: record.id
    },
    selfStaked: {
      asset: OnomyHubConstants.NOM_ASSET,
      amount: BigInt(record.selfStaked.toFixed(0))
    },
    staked: {
      asset: OnomyHubConstants.NOM_ASSET,
      amount: BigInt(record.totalStaked.shiftedBy(18).toFixed(0))
    },
    votingPowerRatio: record.validator.votingPowerRatio
  };
}
async function getValidator(client, validatorAddress) {
  const delegatorAddress = await client.getAddress();
  const record = await client.getValidatorForDelegator(delegatorAddress, validatorAddress.id);
  return record ? validatorRecordToData(record) : null;
}
async function getValidators(client) {
  const delegatorAddress = await client.getAddress();
  const records = await client.getValidatorsForDelegator(delegatorAddress);
  return records.map(validatorRecordToData);
}
async function getDelegations(client) {
  const delegatorAddress = await client.getAddress();
  const records = await client.getValidatorsForDelegator(delegatorAddress);
  return records.map((record) => {
    var _a;
    const validator = {
      description: record.validator.name,
      website: record.validator.website,
      details: record.validator.details,
      securityContact: record.validator.securityContact,
      logoUrl: "",
      estimatedAPR: record.rewards.APR,
      commissionRate: record.rewards.commissionRate,
      selfStakedRatio: record.selfStakeRatio,
      isActive: record.validator.isActive,
      uptimeRatio: 0.99,
      pubKey: record.id,
      address: {
        chain: OnomyHubConstants.ONOMY_CHAIN,
        id: record.id
      },
      delegator: {
        chain: OnomyHubConstants.ONOMY_CHAIN,
        id: record.id
      },
      selfStaked: {
        asset: OnomyHubConstants.NOM_ASSET,
        amount: BigInt(record.selfStaked.toFixed(0))
      },
      staked: {
        asset: OnomyHubConstants.NOM_ASSET,
        amount: BigInt(record.totalStaked.toFixed(0))
      },
      votingPowerRatio: record.validator.votingPowerRatio
    };
    const [unbondingBalance = OnomyHubConstants.UNKNOWN_BALANCE] = OnomyHubUtils.combineBalances((_a = record.unbonding.map((entry) => {
      var _a2;
      return {
        asset: OnomyHubConstants.NOM_ASSET,
        amount: BigInt((_a2 = entry.balance) != null ? _a2 : "0")
      };
    })) != null ? _a : []);
    return {
      validator,
      delegator: {
        chain: OnomyHubConstants.ONOMY_CHAIN,
        id: delegatorAddress
      },
      delegated: {
        asset: OnomyHubConstants.NOM_ASSET,
        amount: BigInt(record.delegated.toFixed(0))
      },
      reward: {
        asset: OnomyHubConstants.NOM_ASSET,
        amount: BigInt(record.rewards.amount.toFixed(0))
      },
      unbonding: unbondingBalance
    };
  });
}
async function getDelegation(client, validatorAddress) {
  var _a;
  const delegations = await OnomyUtils.getDelegations(client);
  return (_a = delegations.find((d) => d.validator.address.id === validatorAddress.id)) != null ? _a : null;
}
const OnomyUtils = {
  requireNom,
  txResToBlockchainTransaction,
  getRewardsForValidator,
  suggestGasPrices: suggestGasPrices$1,
  isAddressValid: isAddressValid$1,
  getValidator,
  getValidators,
  getDelegation,
  getDelegations
};

async function execute$9(client, { asset, validatorAddress, amountFixed, gasMultiplier }) {
  OnomyUtils.requireNom(asset);
  const tx = await client.delegate({
    validatorAddress,
    amountFixed: new BigNumber(amountFixed),
    feeMultiplier: gasMultiplier ? parseFloat(gasMultiplier) : void 0
  });
  const transaction = await OnomyUtils.txResToBlockchainTransaction(client, tx);
  return {
    amountFixed,
    amount: new BigNumber(amountFixed).shiftedBy(-18),
    transaction
  };
}
async function estimateGas$9(client, params) {
  const { asset, validatorAddress, amountFixed } = params;
  OnomyUtils.requireNom(asset);
  const amountBn = new BigNumber(amountFixed);
  try {
    const {
      amount: [fee]
    } = await client.feesForDelegate({
      validatorAddress,
      amountFixed: amountBn.gt(0) ? amountBn : new BigNumber(1),
      feeMultiplier: params.gasMultiplier ? parseFloat(params.gasMultiplier) : void 0
    });
    return fee.amount;
  } catch (e) {
    if ("message" in e) {
      if (/Account does not exist on chain/.test(e.message)) {
        return "1";
      }
    }
    throw e;
  }
}
async function calculateMax$5(client, params) {
  const { asset } = params;
  OnomyUtils.requireNom(asset);
  const gasEst = await OnomyDelegateAsset.estimateGas(client, {
    ...params
  });
  const balanceBigNum = new BigNumber(params.amountFixed || "0");
  const gasEstBigNum = new BigNumber(gasEst);
  const gasPriceBigNum = new BigNumber(params.gasMultiplier || "0");
  const feeTotalBigNum = gasEstBigNum.times(gasPriceBigNum);
  const maxAmountBigNum = balanceBigNum.minus(feeTotalBigNum);
  return {
    ...params,
    amountFixed: maxAmountBigNum.toFixed()
  };
}
function init$e(client) {
  return {
    execute(params) {
      return OnomyDelegateAsset.execute(client, params);
    },
    calculateMax(params) {
      return OnomyDelegateAsset.calculateMax(client, params);
    },
    estimateGas(params) {
      return OnomyDelegateAsset.estimateGas(client, params);
    }
  };
}
const OnomyDelegateAsset = {
  init: init$e,
  execute: execute$9,
  estimateGas: estimateGas$9,
  calculateMax: calculateMax$5
};

async function execute$8(client, { asset, validatorAddress, amountFixed, gasMultiplier }) {
  OnomyUtils.requireNom(asset);
  const tx = await client.undelegate({
    validatorAddress,
    amountFixed: new BigNumber(amountFixed),
    feeMultiplier: gasMultiplier ? parseFloat(gasMultiplier) : 1
  });
  const transaction = await OnomyUtils.txResToBlockchainTransaction(client, tx);
  return {
    amountFixed,
    amount: new BigNumber(amountFixed).shiftedBy(-18),
    transaction
  };
}
async function estimateGas$8(client, params) {
  const { asset, validatorAddress, amountFixed } = params;
  OnomyUtils.requireNom(asset);
  const amountBn = new BigNumber(amountFixed);
  try {
    const {
      amount: [fee]
    } = await client.feesForUndelegate({
      validatorAddress,
      amountFixed: amountBn.gt(0) ? amountBn : new BigNumber(1),
      feeMultiplier: 1
    });
    return fee.amount;
  } catch (e) {
    if ("message" in e) {
      if (/Account does not exist on chain/.test(e.message)) {
        return "1";
      }
    }
    throw e;
  }
}
function init$d(client) {
  return {
    execute(params) {
      return OnomyUndelegateAsset.execute(client, params);
    },
    estimateGas(params) {
      return OnomyUndelegateAsset.estimateGas(client, params);
    }
  };
}
const OnomyUndelegateAsset = {
  init: init$d,
  execute: execute$8,
  estimateGas: estimateGas$8
};

async function execute$7(client, { asset, validatorAddress, gasMultiplier }) {
  OnomyUtils.requireNom(asset);
  const tx = await client.withdrawRewards({
    validatorAddress,
    feeMultiplier: gasMultiplier ? parseFloat(gasMultiplier) : void 0
  });
  return OnomyUtils.txResToBlockchainTransaction(client, tx);
}
async function estimateGas$7(client, params) {
  const { asset, validatorAddress } = params;
  OnomyUtils.requireNom(asset);
  try {
    const {
      amount: [fee]
    } = await client.feesForWithdrawRewards({
      validatorAddress,
      feeMultiplier: 1
    });
    return fee.amount;
  } catch (e) {
    if ("message" in e) {
      if (/Account does not exist on chain/.test(e.message)) {
        return "1";
      }
    }
    throw e;
  }
}
function init$c(client) {
  return {
    execute(params) {
      return OnomyClaimReward.execute(client, params);
    },
    estimateGas(params) {
      return OnomyClaimReward.estimateGas(client, params);
    }
  };
}
const OnomyClaimReward = {
  init: init$c,
  execute: execute$7,
  estimateGas: estimateGas$7
};

async function execute$6(client, { asset, destAddress, amountFixed, gasMultiplier }) {
  OnomyUtils.requireNom(asset);
  const tx = await client.transferDenom({
    destinationAddress: destAddress,
    amountFixed: new BigNumber(amountFixed),
    denom: asset.id,
    feeMultiplier: gasMultiplier ? parseFloat(gasMultiplier) : void 0
  });
  return OnomyUtils.txResToBlockchainTransaction(client, tx);
}
async function estimateGas$6(client, params) {
  const { asset, destAddress, amountFixed } = params;
  OnomyUtils.requireNom(asset);
  const amtBigNumber = new BigNumber(amountFixed);
  const isValidAddress = OnomyUtils.isAddressValid({
    chain: OnomyHubConstants.ONOMY_CHAIN,
    id: destAddress
  });
  try {
    const {
      amount: [fee]
    } = await client.feesForTransferDenom({
      destinationAddress: isValidAddress ? destAddress : await client.getAddress(),
      amountFixed: amtBigNumber.gt(0) ? amtBigNumber : new BigNumber(1),
      denom: asset.id,
      feeMultiplier: 1
    });
    return fee.amount;
  } catch (e) {
    if ("message" in e) {
      if (/Account does not exist on chain/.test(e.message)) {
        return "1";
      }
    }
    throw e;
  }
}
async function calculateMax$4(client, params) {
  var _a;
  const { destAddress } = params;
  if (((_a = params.asset) == null ? void 0 : _a.id) !== OnomyHubConstants.NOM_ASSET.id)
    return params;
  const isValidAddress = OnomyUtils.isAddressValid({
    chain: OnomyHubConstants.ONOMY_CHAIN,
    id: destAddress
  });
  const gasEst = await OnomyTransferAsset.estimateGas(client, {
    ...params,
    destAddress: isValidAddress ? destAddress : await client.getAddress(),
    amountFixed: "1"
  });
  const balanceBigNum = new BigNumber(params.amountFixed || "0");
  const gasEstBigNum = new BigNumber(gasEst);
  const gasPriceBigNum = new BigNumber(params.gasMultiplier || "0");
  const feeTotalBigNum = gasEstBigNum.times(gasPriceBigNum);
  const maxAmountBigNum = balanceBigNum.minus(feeTotalBigNum);
  return {
    ...params,
    amountFixed: maxAmountBigNum.gt(0) ? maxAmountBigNum.toFixed() : "0"
  };
}
function init$b(client) {
  return {
    execute(params) {
      return OnomyTransferAsset.execute(client, params);
    },
    estimateGas(params) {
      return OnomyTransferAsset.estimateGas(client, params);
    },
    calculateMax(params) {
      return OnomyTransferAsset.calculateMax(client, params);
    }
  };
}
const OnomyTransferAsset = {
  init: init$b,
  execute: execute$6,
  estimateGas: estimateGas$6,
  calculateMax: calculateMax$4
};

async function execute$5(client, { asset, validatorAddress, gasMultiplier }) {
  OnomyUtils.requireNom(asset);
  const amountFixed = await OnomyUtils.getRewardsForValidator(client, validatorAddress);
  const tx = await client.delegate({
    validatorAddress,
    amountFixed: new BigNumber(amountFixed),
    feeMultiplier: gasMultiplier ? parseFloat(gasMultiplier) : void 0
  });
  return OnomyUtils.txResToBlockchainTransaction(client, tx);
}
async function estimateGas$5(client, params) {
  const { asset, validatorAddress } = params;
  OnomyUtils.requireNom(asset);
  const amountFixed = await OnomyUtils.getRewardsForValidator(client, validatorAddress);
  try {
    const {
      amount: [fee]
    } = await client.feesForDelegate({
      validatorAddress,
      amountFixed: new BigNumber(amountFixed),
      feeMultiplier: 1
    });
    return fee.amount;
  } catch (e) {
    if ("message" in e) {
      if (/Account does not exist on chain/.test(e.message)) {
        return "1";
      }
    }
    throw e;
  }
}
function init$a(client) {
  return {
    execute(params) {
      return OnomyRedelegateAsset.execute(client, params);
    },
    estimateGas(params) {
      return OnomyRedelegateAsset.estimateGas(client, params);
    }
  };
}
const OnomyRedelegateAsset = {
  init: init$a,
  execute: execute$5,
  estimateGas: estimateGas$5
};

async function execute$4(client, {
  asset,
  srcValidatorAddress,
  dstValidatorAddress,
  gasMultiplier,
  amountFixed
}) {
  OnomyUtils.requireNom(asset);
  const tx = await client.redelegate({
    srcValidatorAddress,
    dstValidatorAddress,
    amountFixed: new BigNumber(amountFixed),
    feeMultiplier: gasMultiplier ? parseFloat(gasMultiplier) : void 0
  });
  const transaction = OnomyUtils.txResToBlockchainTransaction(client, tx);
  return {
    amountFixed,
    amount: new BigNumber(amountFixed).shiftedBy(-18),
    srcValidatorAddress,
    dstValidatorAddress,
    transaction
  };
}
async function estimateGas$4(client, params) {
  const { asset, srcValidatorAddress, dstValidatorAddress, amountFixed } = params;
  const amountBn = new BigNumber(amountFixed);
  OnomyUtils.requireNom(asset);
  try {
    const {
      amount: [fee]
    } = await client.feesForRedelegate({
      srcValidatorAddress,
      dstValidatorAddress,
      feeMultiplier: 1,
      amountFixed: amountBn.gt(0) ? amountBn : new BigNumber(1)
    });
    return fee.amount;
  } catch (e) {
    if ("message" in e) {
      if (/Account does not exist on chain/.test(e.message)) {
        return "1";
      }
    }
    throw e;
  }
}
async function calculateMax$3(client, params) {
  const { asset } = params;
  OnomyUtils.requireNom(asset);
  const gasEst = await OnomyMoveDelegation.estimateGas(client, {
    ...params
  });
  const balanceBigNum = new BigNumber(params.amountFixed || "0");
  const gasEstBigNum = new BigNumber(gasEst);
  const gasPriceBigNum = new BigNumber(params.gasMultiplier || "0");
  const feeTotalBigNum = gasEstBigNum.times(gasPriceBigNum);
  const maxAmountBigNum = balanceBigNum.minus(feeTotalBigNum);
  return {
    ...params,
    amountFixed: maxAmountBigNum.toFixed()
  };
}
function init$9(client) {
  return {
    execute(params) {
      return OnomyMoveDelegation.execute(client, params);
    },
    estimateGas(params) {
      return OnomyMoveDelegation.estimateGas(client, params);
    },
    calculateMax(params) {
      return OnomyMoveDelegation.calculateMax(client, params);
    }
  };
}
const OnomyMoveDelegation = {
  init: init$9,
  execute: execute$4,
  estimateGas: estimateGas$4,
  calculateMax: calculateMax$3
};

async function getAddresses$2(wallet) {
  const accounts = await wallet.onomy.getAccounts();
  return accounts.map((acct) => {
    return {
      chain: OnomyHubConstants.ONOMY_CHAIN,
      id: acct.address
    };
  });
}
async function getBalance$1(client, { asset, address }) {
  var _a;
  try {
    const addr = (_a = address == null ? void 0 : address.id) != null ? _a : await client.getAddress();
    if (!addr)
      return "0";
    const balance = await client.getAddressBalance(addr, asset.id);
    return balance;
  } catch (e) {
    if (e instanceof OnomyClientErrors.NoOnomySignerError) {
      return "0";
    }
    throw e;
  }
}
async function init$8({ wallet, onomyRpcUrl }) {
  const onomyClient = new OnomyClient(onomyRpcUrl);
  onomyClient.setSignerFn(() => wallet.onomy.getSigner());
  return {
    client: onomyClient,
    wallet: wallet.onomy,
    isAddressValid: OnomyUtils.isAddressValid,
    getAddresses() {
      return OnomyChain._.getAddresses(wallet);
    },
    getBalance(params) {
      return OnomyChain._.getBalance(onomyClient, params);
    },
    async getDelegation(validatorAddress) {
      return OnomyUtils.getDelegation(onomyClient, validatorAddress);
    },
    getDelegations() {
      return OnomyUtils.getDelegations(onomyClient);
    },
    TransferAsset: OnomyTransferAsset.init(onomyClient),
    DelegateAsset: OnomyDelegateAsset.init(onomyClient),
    UndelegateAsset: OnomyUndelegateAsset.init(onomyClient),
    RedelegateAsset: OnomyRedelegateAsset.init(onomyClient),
    ClaimReward: OnomyClaimReward.init(onomyClient),
    MoveDelegation: OnomyMoveDelegation.init(onomyClient),
    suggestGasPrices(params) {
      return OnomyUtils.suggestGasPrices(params);
    }
  };
}
const OnomyChain = {
  init: init$8,
  requireNom: OnomyUtils.requireNom,
  _: {
    getAddresses: getAddresses$2,
    getBalance: getBalance$1
  }
};

var ERC20ABI = [
	{
		constant: true,
		inputs: [
		],
		name: "name",
		outputs: [
			{
				name: "",
				type: "string"
			}
		],
		payable: false,
		stateMutability: "view",
		type: "function"
	},
	{
		constant: false,
		inputs: [
			{
				name: "_spender",
				type: "address"
			},
			{
				name: "_value",
				type: "uint256"
			}
		],
		name: "approve",
		outputs: [
			{
				name: "",
				type: "bool"
			}
		],
		payable: false,
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		constant: true,
		inputs: [
		],
		name: "totalSupply",
		outputs: [
			{
				name: "",
				type: "uint256"
			}
		],
		payable: false,
		stateMutability: "view",
		type: "function"
	},
	{
		constant: false,
		inputs: [
			{
				name: "_from",
				type: "address"
			},
			{
				name: "_to",
				type: "address"
			},
			{
				name: "_value",
				type: "uint256"
			}
		],
		name: "transferFrom",
		outputs: [
			{
				name: "",
				type: "bool"
			}
		],
		payable: false,
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		constant: true,
		inputs: [
		],
		name: "decimals",
		outputs: [
			{
				name: "",
				type: "uint8"
			}
		],
		payable: false,
		stateMutability: "view",
		type: "function"
	},
	{
		constant: true,
		inputs: [
			{
				name: "_owner",
				type: "address"
			}
		],
		name: "balanceOf",
		outputs: [
			{
				name: "balance",
				type: "uint256"
			}
		],
		payable: false,
		stateMutability: "view",
		type: "function"
	},
	{
		constant: true,
		inputs: [
		],
		name: "symbol",
		outputs: [
			{
				name: "",
				type: "string"
			}
		],
		payable: false,
		stateMutability: "view",
		type: "function"
	},
	{
		constant: false,
		inputs: [
			{
				name: "_to",
				type: "address"
			},
			{
				name: "_value",
				type: "uint256"
			}
		],
		name: "transfer",
		outputs: [
			{
				name: "",
				type: "bool"
			}
		],
		payable: false,
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		constant: true,
		inputs: [
			{
				name: "_owner",
				type: "address"
			},
			{
				name: "_spender",
				type: "address"
			}
		],
		name: "allowance",
		outputs: [
			{
				name: "",
				type: "uint256"
			}
		],
		payable: false,
		stateMutability: "view",
		type: "function"
	},
	{
		payable: true,
		stateMutability: "payable",
		type: "fallback"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				name: "owner",
				type: "address"
			},
			{
				indexed: true,
				name: "spender",
				type: "address"
			},
			{
				indexed: false,
				name: "value",
				type: "uint256"
			}
		],
		name: "Approval",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				name: "from",
				type: "address"
			},
			{
				indexed: true,
				name: "to",
				type: "address"
			},
			{
				indexed: false,
				name: "value",
				type: "uint256"
			}
		],
		name: "Transfer",
		type: "event"
	}
];

function isAddressValid(address) {
  try {
    return !!utils.getAddress(address.id);
  } catch (e) {
    return false;
  }
}
async function suggestGasPrices(signer) {
  var _a;
  try {
    const [legacyPrice, feeData] = await Promise.all([signer.getGasPrice(), signer.getFeeData()]);
    if (OnomyHubConstants.ETH_GAS_PRICE_URL) {
      const res = await fetch(OnomyHubConstants.ETH_GAS_PRICE_URL);
      const json = await res.json();
      const {
        result: { SafeGasPrice, ProposeGasPrice, FastGasPrice, suggestBaseFee }
      } = json;
      const prices2 = uniq([FastGasPrice, ProposeGasPrice, SafeGasPrice, suggestBaseFee].map((val) => new BigNumber(val).shiftedBy(9).toFixed(0))).slice(0, 3);
      return prices2;
    }
    if ((feeData == null ? void 0 : feeData.maxFeePerGas) && (feeData == null ? void 0 : feeData.lastBaseFeePerGas)) {
      const max = feeData.maxFeePerGas;
      const min = feeData.lastBaseFeePerGas.add("1000000000");
      const mid = new BigNumber(max.sub(min).div(2).add(min).toString()).toFixed(0);
      const prices2 = [max.toString(), mid, min.toString()];
      return prices2;
    }
    const base = new BigNumber(((_a = feeData.gasPrice) != null ? _a : legacyPrice).toString());
    const prices = [base.times(1.5).toFixed(0), base.times(1.25).toFixed(0), base.toFixed(0)];
    return prices;
  } catch (e) {
    console.error("Error suggesting eth gas price", e);
    throw e;
  }
}
const EthereumUtils = {
  isAddressValid,
  suggestGasPrices
};

function toTransactionRequest(signer, params) {
  const { destAddress, amountFixed } = params;
  const amountBigNum = new BigNumber(amountFixed);
  return signer.populateTransaction({
    to: destAddress,
    value: amountBigNum.isNaN() ? utils.parseEther("0") : utils.parseEther(amountBigNum.shiftedBy(-18).toFixed()),
    gasPrice: params.gasMultiplier ? BigNumber$1.from(params.gasMultiplier) : void 0
  });
}
async function estimateGas$3(signer, params) {
  if (!params.asset)
    return "0";
  const isValidAddress = EthereumUtils.isAddressValid({
    chain: OnomyHubConstants.ONOMY_CHAIN,
    id: params.destAddress
  });
  try {
    if (params.asset.id === OnomyHubConstants.ETH_ASSET.id) {
      const txReq = await toTransactionRequest(signer, {
        ...params,
        destAddress: isValidAddress ? params.destAddress : await signer.getAddress()
      });
      const est2 = await signer.estimateGas(txReq);
      return est2.toString();
    }
    const contract = new Contract(params.asset.id, ERC20ABI, signer);
    const est = await contract.estimateGas.transfer(params.destAddress || await signer.getAddress(), new BigNumber(params.amountFixed).isNaN() ? "0" : params.amountFixed);
    return est.toString();
  } catch (e) {
    if ("code" in e && e.code === "UNPREDICTABLE_GAS_LIMIT") {
      return "1";
    }
    if ("code" in e && e.code === "INSUFFICIENT_FUNDS") {
      return "1";
    }
    throw e;
  }
}
async function execute$3(signer, params) {
  var _a, _b, _c, _d;
  if (!params.asset)
    throw new OnomyHubErrors.InvalidParams("Missing asset");
  if (params.asset.id === OnomyHubConstants.ETH_ASSET.id) {
    const txReq = await toTransactionRequest(signer, params);
    const tx2 = await signer.sendTransaction(txReq);
    const txrx2 = await tx2.wait();
    return {
      hash: tx2.hash,
      block: {
        chain: OnomyHubConstants.ETH_CHAIN,
        height: BigInt((_a = txrx2.blockNumber) != null ? _a : 0),
        hash: (_b = txrx2.blockHash) != null ? _b : ""
      }
    };
  }
  const contract = new Contract(params.asset.id, ERC20ABI, signer);
  const tx = await contract.transfer(params.destAddress, params.amountFixed);
  const txrx = await tx.wait();
  return {
    hash: tx.hash,
    block: {
      chain: OnomyHubConstants.ETH_CHAIN,
      height: BigInt((_c = txrx.blockNumber) != null ? _c : 0),
      hash: (_d = txrx.blockHash) != null ? _d : ""
    }
  };
}
async function calculateMax$2(signer, params) {
  var _a;
  if (((_a = params.asset) == null ? void 0 : _a.id) !== OnomyHubConstants.ETH_ASSET.id)
    return params;
  const isValidAddress = EthereumUtils.isAddressValid({
    chain: OnomyHubConstants.ONOMY_CHAIN,
    id: params.destAddress
  });
  const gasEst = await EthereumTransferAsset.estimateGas(signer, {
    ...params,
    destAddress: isValidAddress ? params.destAddress : await signer.getAddress(),
    amountFixed: "1"
  });
  const balanceBigNum = new BigNumber(params.amountFixed || "0");
  const gasEstBigNum = new BigNumber(gasEst);
  const gasPriceBigNum = new BigNumber(params.gasMultiplier || "0");
  const feeTotalBigNum = gasEstBigNum.times(gasPriceBigNum);
  const maxAmountBigNum = balanceBigNum.minus(feeTotalBigNum);
  return {
    ...params,
    amountFixed: maxAmountBigNum.toFixed()
  };
}
function init$7(signer) {
  return {
    execute(params) {
      return EthereumTransferAsset.execute(signer, params);
    },
    estimateGas(params) {
      return EthereumTransferAsset.estimateGas(signer, params);
    },
    calculateMax(params) {
      return EthereumTransferAsset.calculateMax(signer, params);
    }
  };
}
const EthereumTransferAsset = {
  init: init$7,
  estimateGas: estimateGas$3,
  execute: execute$3,
  calculateMax: calculateMax$2
};

async function getAddresses$1(signer) {
  const address = await signer.getAddress();
  return [
    {
      chain: OnomyHubConstants.ETH_CHAIN,
      id: address
    }
  ];
}
async function getBalance(signer, { asset, address }) {
  var _a;
  switch (asset.id) {
    case OnomyHubConstants.ETH_ASSET.id:
      const ethBal = await signer.getBalance(address == null ? void 0 : address.id);
      return ethBal.toString();
    default:
      const contract = new Contract(asset.id, ERC20ABI, signer);
      try {
        const erc20Bal = await contract.balanceOf((_a = address == null ? void 0 : address.id) != null ? _a : await signer.getAddress());
        return erc20Bal.toString();
      } catch (e) {
        console.error("error getting balance for asset", asset, e);
        return "0";
      }
  }
}
async function init$6({ wallet }) {
  const signer = await wallet.ethereum.getSigner();
  return {
    TransferAsset: EthereumTransferAsset.init(signer),
    signer,
    isAddressValid: EthereumUtils.isAddressValid,
    suggestGasPrices(_params) {
      return EthereumUtils.suggestGasPrices(signer);
    },
    getAddresses() {
      return EthereumChain._.getAddresses(signer);
    },
    getBalance(params) {
      return EthereumChain._.getBalance(signer, params);
    }
  };
}
const EthereumChain = {
  init: init$6,
  _: {
    getAddresses: getAddresses$1,
    getBalance
  }
};

function convertBigNum(bigNum) {
  return new BigNumber(bigNum.toString());
}
class NomBondingCurve {
  constructor(bondContract, bNomContract) {
    this.bondContract = bondContract;
    this.bNomContract = bNomContract;
  }
  async bNomSupply() {
    return this.bondContract.getSupplyNOM().then(OnomyHubUtils.normalizeBigNum).catch((e) => {
      console.warn(e);
      return new BigNumber(0);
    });
  }
  async isTradingEnabled() {
    return this.bondContract.getTradingEnabled().catch((e) => {
      console.warn(e);
      return false;
    });
  }
  async bNomAllowance(account, destinationAddress) {
    try {
      const allowance = await this.bNomContract.allowance(account, destinationAddress).then(convertBigNum);
      return allowance;
    } catch (e) {
      console.error("bNomAllowance error", e);
      return new BigNumber(0);
    }
  }
  async bNomBondAllowance(account) {
    return this.bNomAllowance(account, this.bondContract.address);
  }
  async bNomIncreaseAllowance(destinationAddress, amountAtoms, gasPriceWei) {
    const tx = await this.bNomContract.increaseAllowance(destinationAddress, amountAtoms.toFixed(0), {
      gasPrice: gasPriceWei.toFixed(0)
    });
    const receipt = await tx.wait();
    return [receipt, tx];
  }
  bNomIncreaseBondAllowance(amountAtoms, gasPriceWei) {
    return this.bNomIncreaseAllowance(this.bondContract.address, amountAtoms, gasPriceWei);
  }
  bondBuyQuoteETH(amountWei) {
    return this.bondContract.buyQuoteETH(amountWei.toFixed(0)).then(convertBigNum).catch((e) => {
      console.warn(e);
      return new BigNumber(0);
    });
  }
  bondSellQuoteNOM(amountAtoms) {
    return this.bondContract.sellQuoteNOM(amountAtoms.toFixed(0)).then(convertBigNum);
  }
  async estGasForBuyNOM(bidAmountWei, askAmountAtoms, slippageAtoms) {
    const gasEstimate = await this.bondContract.estimateGas.buyNOM(askAmountAtoms.toFixed(0), slippageAtoms.toFixed(0), {
      value: bidAmountWei.toFixed(0)
    });
    return gasEstimate.toString();
  }
  async bondBuyNOM(bidAmountWei, askAmountAtoms, slippageAtoms, gasPriceWei) {
    const gasEstimateRaw = await this.bondContract.estimateGas.buyNOM(askAmountAtoms.toFixed(0), slippageAtoms.toFixed(0), {
      value: bidAmountWei.toFixed(0)
    });
    const gasFee = new BigNumber(gasEstimateRaw.toString());
    const gas = gasFee.times(gasPriceWei);
    if (bidAmountWei.lt(gas)) {
      throw new Error("lowBid");
    }
    const tx = await this.bondContract.buyNOM(askAmountAtoms.toFixed(0), slippageAtoms.toFixed(0), {
      value: bidAmountWei.toFixed(0),
      gasPrice: gasPriceWei.toFixed(0)
    });
    const receipt = await tx.wait();
    return [receipt, tx];
  }
  async estGasForSellNOM(bidAmountWei, askAmountAtoms, slippageAtoms) {
    const gasEstimate = await this.bondContract.estimateGas.sellNOM(askAmountAtoms.toFixed(0), bidAmountWei.toFixed(0), slippageAtoms.toFixed(0));
    return gasEstimate.toString();
  }
  async bondSellNOM(bidAmountWei, askAmountAtoms, slippageAtoms, gasPriceWei) {
    const tx = await this.bondContract.sellNOM(askAmountAtoms.toFixed(0), bidAmountWei.toFixed(0), slippageAtoms.toFixed(0), {
      gasPrice: gasPriceWei.toFixed(0)
    });
    const receipt = await tx.wait();
    return [receipt, tx];
  }
}

function init$5({
  chain,
  nomContractAddress,
  bondContractAddress
}) {
  const bondContract = BondingCont(bondContractAddress, chain.signer);
  const NOMContract = ERC20Cont(nomContractAddress, chain.signer);
  const actions = new NomBondingCurve(bondContract, NOMContract);
  return {
    bondContract,
    NOMContract,
    actions,
    async getState() {
      const address = await chain.signer.getAddress();
      const [isTradingEnabled, currentETHPrice, NOMallowance, supplyNOM] = await Promise.all([
        actions.isTradingEnabled(),
        actions.bondBuyQuoteETH(new BigNumber(10 ** 18)),
        actions.bNomBondAllowance(address).then(OnomyHubUtils.normalizeBigNum),
        actions.bNomSupply()
      ]);
      const currentNOMPrice = new BigNumber(1).div(currentETHPrice);
      return {
        isTradingEnabled,
        currentETHPrice,
        currentNOMPrice,
        NOMallowance,
        supplyNOM
      };
    }
  };
}
const BondingCurve = {
  init: init$5
};

function getParamsErrors$2(params, ethBalanceFixed = "0", gasLimitFixed = "0") {
  const errors = {};
  const amount = new BigNumber(params.ethBidAmountFixed || "0");
  const totalAmount = amount.plus(gasLimitFixed);
  if (!params.ethBidAmountFixed)
    errors.ethBidAmountFixed = "Required";
  if (totalAmount.gt(ethBalanceFixed))
    errors.ethBidAmountFixed = "Exceeds Available ETH";
  if (amount.lte(0))
    errors.ethBidAmountFixed = "Must be > 0";
  return Object.values(errors).find((x) => x) ? errors : null;
}
async function estimateGas$2(bc, params) {
  const ethBidAmount = new BigNumber(params.ethBidAmountFixed);
  const bNomAskAmount = new BigNumber(params.bNomAskAmountFixed);
  const bNomSlippage = new BigNumber(params.slippagePoints);
  try {
    const res = await bc.estGasForBuyNOM(ethBidAmount.isNaN() ? new BigNumber(1) : ethBidAmount, bNomAskAmount.isNaN() ? new BigNumber(1) : bNomAskAmount, bNomSlippage.isNaN() ? new BigNumber(1e3) : bNomSlippage);
    return res;
  } catch (e) {
    if ("code" in e && e.code === "UNPREDICTABLE_GAS_LIMIT") {
      return "1";
    }
    if ("code" in e && e.code === "INSUFFICIENT_FUNDS") {
      return "1";
    }
    throw e;
  }
}
async function calculateMax$1(bc, params, ethBalanceFixed = "0") {
  const gasEst = await BuyBridgeNom.estimateGas(bc, params);
  const balanceBigNum = new BigNumber(ethBalanceFixed);
  const gasEstBigNum = new BigNumber(gasEst);
  const gasPriceBigNum = new BigNumber(params.gasMultiplier || "0");
  const feeTotalBigNum = gasEstBigNum.times(gasPriceBigNum);
  const maxAmountBigNum = balanceBigNum.minus(feeTotalBigNum);
  return {
    ...params,
    ethBidAmountFixed: maxAmountBigNum.toFixed(0)
  };
}
async function quote$1(bc, { ethBidAmountFixed }) {
  const ethBidAmount = new BigNumber(ethBidAmountFixed);
  const res = await bc.bondBuyQuoteETH(ethBidAmount);
  return res.toFixed(0);
}
async function execute$2(bc, balances, params) {
  var _a, _b;
  const ethBidAmountBigNum = new BigNumber(params.ethBidAmountFixed);
  const bNomAskAmount = new BigNumber(params.bNomAskAmountFixed);
  const bNomSlippage = new BigNumber(params.slippagePoints);
  const gasPrice = new BigNumber(params.gasMultiplier || "1");
  const [
    [bNomBalanceBefore, ethBalanceBefore],
    [ethReceipt, ethTx],
    [bNomBalanceAfter, ethBalanceAfter]
  ] = await balances.beforeAndAfterMultiple([[OnomyHubConstants.BNOM_ASSET], [OnomyHubConstants.ETH_ASSET]], () => bc.bondBuyNOM(ethBidAmountBigNum, bNomAskAmount, bNomSlippage, gasPrice));
  const [bNomIncrease, ethDecrease, ethBidAmount] = await Promise.all([
    balances.subtract(bNomBalanceAfter, bNomBalanceBefore),
    balances.subtract(ethBalanceBefore, ethBalanceAfter),
    balances.includeDetails({
      asset: OnomyHubConstants.ETH_ASSET,
      amount: BigInt(params.ethBidAmountFixed)
    })
  ]);
  const ethGasPaid = await balances.includeDetails({
    asset: OnomyHubConstants.ETH_ASSET,
    amount: ethDecrease.amount - ethBidAmount.amount
  });
  return {
    bNomBalanceBefore,
    ethBalanceBefore,
    bNomBalanceAfter,
    ethBalanceAfter,
    ethBidAmount,
    ethGasPaid,
    bNomIncrease,
    ethDecrease,
    ethReceipt,
    ethTx,
    transaction: {
      hash: ethTx.hash,
      block: {
        chain: OnomyHubConstants.ETH_CHAIN,
        height: BigInt((_a = ethReceipt.blockNumber) != null ? _a : 0),
        hash: (_b = ethReceipt.blockHash) != null ? _b : ""
      }
    }
  };
}
function init$4(bc, balances) {
  return {
    getParamsErrors(params, ethBalanceFixed, gasLimitFixed) {
      return BuyBridgeNom.getParamsErrors(params, ethBalanceFixed, gasLimitFixed);
    },
    estimateGas(params) {
      return BuyBridgeNom.estimateGas(bc, params);
    },
    calculateMax(params, ethBalanceFixed = "0") {
      return BuyBridgeNom.calculateMax(bc, params, ethBalanceFixed);
    },
    quote(params) {
      return BuyBridgeNom.quote(bc, params);
    },
    execute(params) {
      return BuyBridgeNom.execute(bc, balances, params);
    }
  };
}
const BuyBridgeNom = {
  init: init$4,
  getParamsErrors: getParamsErrors$2,
  quote: quote$1,
  estimateGas: estimateGas$2,
  calculateMax: calculateMax$1,
  execute: execute$2
};

function getParamsErrors$1(params, bNomBalanceFixed = "0") {
  const errors = {};
  const amount = new BigNumber(params.bNomAskAmountFixed || "0");
  if (!params.bNomAskAmountFixed)
    errors.bNomAskAmountFixed = "Required";
  if (amount.gt(bNomBalanceFixed))
    errors.bNomAskAmountFixed = "Insufficient bNOM balance";
  if (amount.lte(0))
    errors.bNomAskAmountFixed = "Must be > 0";
  return Object.values(errors).find((x) => x) ? errors : null;
}
async function estimateGas$1(bc, params) {
  const ethBidAmount = new BigNumber(params.ethBidAmountFixed);
  const bNomAskAmount = new BigNumber(params.bNomAskAmountFixed);
  const bNomSlippage = new BigNumber(params.slippagePoints);
  try {
    const res = await bc.estGasForSellNOM(ethBidAmount.isNaN() ? new BigNumber(1) : ethBidAmount, bNomAskAmount.isNaN() ? new BigNumber(1) : bNomAskAmount, bNomSlippage.isNaN() ? new BigNumber(1e3) : bNomSlippage);
    return res;
  } catch (e) {
    if ("code" in e && e.code === "UNPREDICTABLE_GAS_LIMIT") {
      return "100000";
    }
    throw e;
  }
}
async function quote(bc, { bNomAskAmountFixed }) {
  const bNomAskAmount = new BigNumber(bNomAskAmountFixed);
  const res = await bc.bondSellQuoteNOM(bNomAskAmount);
  return res.toFixed(0);
}
async function approve(bc, approveFixed, gasPriceFixed) {
  var _a, _b;
  const [ethReceipt, ethTx] = await bc.bNomIncreaseBondAllowance(new BigNumber(approveFixed), new BigNumber(gasPriceFixed));
  return {
    ethReceipt,
    ethTx,
    transaction: {
      hash: ethTx.hash,
      block: {
        chain: OnomyHubConstants.ETH_CHAIN,
        height: BigInt((_a = ethReceipt.blockNumber) != null ? _a : 0),
        hash: (_b = ethReceipt.blockHash) != null ? _b : ""
      }
    }
  };
}
async function execute$1(bc, balances, params) {
  var _a, _b;
  const ethBidAmount = new BigNumber(params.ethBidAmountFixed);
  const bNomAskAmount = new BigNumber(params.bNomAskAmountFixed);
  const bNomSlippage = new BigNumber(params.slippagePoints);
  const gasPrice = new BigNumber(params.gasMultiplier || "1");
  const [
    [bNomBalanceBefore, ethBalanceBefore],
    [ethReceipt, ethTx],
    [bNomBalanceAfter, ethBalanceAfter]
  ] = await balances.beforeAndAfterMultiple([[OnomyHubConstants.BNOM_ASSET], [OnomyHubConstants.ETH_ASSET]], () => bc.bondSellNOM(ethBidAmount, bNomAskAmount, bNomSlippage, gasPrice));
  const [bNomDecrease, ethIncrease] = await Promise.all([
    balances.subtract(bNomBalanceBefore, bNomBalanceAfter),
    balances.subtract(ethBalanceAfter, ethBalanceBefore)
  ]);
  return {
    bNomBalanceBefore,
    ethBalanceBefore,
    bNomBalanceAfter,
    ethBalanceAfter,
    bNomDecrease,
    ethIncrease,
    ethReceipt,
    ethTx,
    transaction: {
      hash: ethTx.hash,
      block: {
        chain: OnomyHubConstants.ETH_CHAIN,
        height: BigInt((_a = ethReceipt.blockNumber) != null ? _a : 0),
        hash: (_b = ethReceipt.blockHash) != null ? _b : ""
      }
    }
  };
}
function init$3(bc, balances) {
  return {
    getParamsErrors(params, bNomBalanceFixed) {
      return SellBridgeNom.getParamsErrors(params, bNomBalanceFixed);
    },
    estimateGas(params) {
      return SellBridgeNom.estimateGas(bc, params);
    },
    quote(params) {
      return SellBridgeNom.quote(bc, params);
    },
    approve(approveFixed, gasPriceFixed) {
      return SellBridgeNom.approve(bc, approveFixed, gasPriceFixed);
    },
    execute(params) {
      return SellBridgeNom.execute(bc, balances, params);
    }
  };
}
const SellBridgeNom = {
  init: init$3,
  getParamsErrors: getParamsErrors$1,
  quote,
  estimateGas: estimateGas$1,
  approve,
  execute: execute$1
};

class BridgeEthNomToNom extends AbstractGravityBridge {
  getFromAsset() {
    return OnomyHubConstants.ETH_NOM_ASSET;
  }
  getToAsset() {
    return OnomyHubConstants.NOM_ASSET;
  }
}

class BridgeNomToEthNom extends AbstractAssetBridge {
  constructor() {
    super(...arguments);
    this.fixedBridgeFee = "20000000000000000000";
    this.ethBlockWait = 64;
  }
  getFromAsset() {
    return OnomyHubConstants.NOM_ASSET;
  }
  getToAsset() {
    return OnomyHubConstants.ETH_NOM_ASSET;
  }
  getGasAsset() {
    return OnomyHubConstants.NOM_ASSET;
  }
  getBridgeFee() {
    const amount = {
      asset: OnomyHubConstants.NOM_ASSET,
      amount: BigInt(this.fixedBridgeFee)
    };
    return this.balances.includeDetails(amount);
  }
  async estimateTxGas(params) {
    const { amount, gasPrice } = params;
    const dest = await this.getDestinationAddress(params);
    const {
      amount: [fee]
    } = await this.chains.onomy.client.feesForSendToEth({
      ethDest: dest.id,
      amountFixed: new BigNumber(amount.amount.toString()),
      feeMultiplier: parseInt(gasPrice, 10),
      bridgeFeeFixed: new BigNumber(this.fixedBridgeFee)
    });
    return fee.amount;
  }
  async doBridgeTxSend(params) {
    var _a, _b;
    const { amount, gasPrice } = params;
    const dest = await this.getDestinationAddress(params);
    const res = await this.chains.onomy.client.sendToEth({
      ethDest: dest.id,
      amountFixed: new BigNumber(amount.amount.toString()),
      feeMultiplier: parseInt(gasPrice, 10),
      bridgeFeeFixed: new BigNumber(this.fixedBridgeFee)
    });
    return {
      hash: res.transactionHash,
      block: {
        chain: OnomyHubConstants.ONOMY_CHAIN,
        height: BigInt((_a = res.height) != null ? _a : 0),
        hash: (_b = res.height.toString()) != null ? _b : ""
      }
    };
  }
  doBridgeProgress(params, txResult, cb) {
    const ethProvider = this.chains.ethereum.signer.provider;
    let startBlockNumber = 0;
    const blocksToWait = this.ethBlockWait;
    let lastBlock = startBlockNumber;
    const onBlock = (bNumber) => {
      if (bNumber <= lastBlock)
        return;
      if (startBlockNumber === 0)
        startBlockNumber = bNumber;
      lastBlock = bNumber;
      const elapsed = bNumber - startBlockNumber;
      if (elapsed >= blocksToWait) {
        cb({
          type: "WAITING",
          txResult,
          progressUnits: blocksToWait,
          totalUnits: blocksToWait,
          unitDescription: "blocks",
          description: `Waiting for validation`,
          fromAsset: this.getFromAsset(),
          toAsset: this.getToAsset(),
          params
        });
      } else {
        cb({
          type: "INPROGRESS",
          txResult,
          progressUnits: elapsed,
          totalUnits: blocksToWait,
          unitDescription: "blocks",
          description: `${elapsed}/${blocksToWait} - 96 ETH blocks remain`,
          fromAsset: this.getFromAsset(),
          toAsset: this.getToAsset(),
          params
        });
      }
    };
    ethProvider == null ? void 0 : ethProvider.on("block", onBlock);
    this.onToBalance((newBalance) => {
      if (newBalance.amount >= txResult.expectedToBalanceAfterBridge.amount) {
        ethProvider == null ? void 0 : ethProvider.off("block", onBlock);
        cb({
          type: "COMPLETE",
          txResult,
          progressUnits: blocksToWait,
          totalUnits: blocksToWait,
          unitDescription: "blocks",
          description: `Bridge successful`,
          fromAsset: this.getFromAsset(),
          toAsset: this.getToAsset(),
          params
        });
      }
    }, txResult.destination);
  }
}

function getParamsErrors(chains, params, assetBalanceFixed = "0") {
  const errors = {};
  if (params.asset.chain.name !== OnomyHubConstants.ONOMY_CHAIN.name || params.asset.id !== OnomyHubConstants.NOM_ASSET.id) {
    errors.asset = "Asset must be NOM";
  }
  const { srcValidatorAddress, dstValidatorAddress, amountFixed } = params;
  if (!srcValidatorAddress) {
    errors.srcValidatorAddress = "Required";
  } else if (params.asset) {
    if (!OnomyHubChains.isAddressValid(chains, {
      chain: params.asset.chain,
      id: params.srcValidatorAddress
    })) {
      errors.srcValidatorAddress = "Invalid Address";
    }
  }
  if (!dstValidatorAddress) {
    errors.dstValidatorAddress = "Required";
  } else if (params.asset) {
    if (!OnomyHubChains.isAddressValid(chains, {
      chain: params.asset.chain,
      id: params.srcValidatorAddress
    })) {
      errors.srcValidatorAddress = "Invalid Address";
    }
  }
  const amount = new BigNumber(amountFixed || "0");
  if (amount.gt(assetBalanceFixed))
    errors.amountFixed = "Insufficient stake";
  if (amount.isNaN())
    errors.amountFixed = "Invalid amount";
  if (amount.lte(0))
    errors.amountFixed = "Must be > 0";
  return Object.values(errors).find((x) => x) ? errors : null;
}
async function estimateGas(chains, params) {
  switch (params.asset.chain.name) {
    case OnomyHubConstants.ONOMY_CHAIN.name:
      return chains.onomy.MoveDelegation.estimateGas(params);
    default:
      throw new OnomyHubErrors.UnsupportedStakingChain();
  }
}
async function calculateMax(chains, params) {
  switch (params.asset.chain.name) {
    case OnomyHubConstants.ONOMY_CHAIN.name:
      return chains.onomy.MoveDelegation.calculateMax(params);
    default:
      throw new OnomyHubErrors.UnsupportedStakingChain();
  }
}
async function execute(chains, balances, delegations, params, assetBalanceFixed = "0") {
  const paramsErrors = MoveDelegation.getParamsErrors(chains, params, assetBalanceFixed);
  if (paramsErrors) {
    console.error("params errors", paramsErrors);
    throw new OnomyHubErrors.InvalidParams();
  }
  const srcValidatorAddress = {
    chain: params.asset.chain,
    id: params.srcValidatorAddress
  };
  const dstValidatorAddress = {
    chain: params.asset.chain,
    id: params.srcValidatorAddress
  };
  const delegationBefore = await Promise.all([
    delegations.forceGet(srcValidatorAddress),
    delegations.forceGet(dstValidatorAddress)
  ]);
  const [balanceBefore, res, balanceAfter] = await balances.beforeAndAfter(params.asset, async () => {
    switch (params.asset.chain.name) {
      case OnomyHubConstants.ONOMY_CHAIN.name:
        return chains.onomy.MoveDelegation.execute(params);
      default:
        throw new OnomyHubErrors.UnsupportedStakingChain();
    }
  });
  const delegationAmount = await balances.includeDetails({
    asset: balanceBefore.asset,
    amount: BigInt(params.amountFixed)
  });
  const delegationAfter = delegations.forceGet(srcValidatorAddress);
  return {
    ...res,
    delegationAmount,
    delegationBefore,
    delegationAfter,
    balanceBefore,
    balanceAfter
  };
}
function init$2(chains, balances, delegations) {
  return {
    execute(params, assetBalanceFixed = "0") {
      return MoveDelegation.execute(chains, balances, delegations, params, assetBalanceFixed);
    },
    getParamsErrors(params, assetBalanceFixed = "0") {
      return MoveDelegation.getParamsErrors(chains, params, assetBalanceFixed);
    },
    estimateGas(params) {
      return MoveDelegation.estimateGas(chains, params);
    },
    calculateMax(params) {
      return MoveDelegation.calculateMax(chains, params);
    }
  };
}
const MoveDelegation = {
  init: init$2,
  execute,
  getParamsErrors,
  estimateGas,
  calculateMax
};

class OnomyGovProposals extends AbstractThrottledAsyncCache {
  constructor(chains) {
    super();
    this.chains = chains;
  }
  cacheKey([chainName, id]) {
    return [chainName, id].join("-");
  }
  async implementation(chainName, proposalId) {
    if (chainName !== OnomyHubConstants.ONOMY_CHAIN.name)
      throw new Error("Only onomy governance currently supported");
    const res = this.chains.onomy.client.getProposal(proposalId);
    return res;
  }
}

async function getAddresses(wallet) {
  const ethAddress = await (await wallet.ethereum.getSigner()).getAddress();
  const [{ address: onomyAddress }] = await wallet.onomy.getAccounts();
  return [
    {
      chainId: OnomyHubConstants.ETH_CHAIN_ID,
      address: ethAddress
    },
    {
      chainId: OnomyHubConstants.ONOMY_CHAIN_ID,
      address: onomyAddress
    }
  ];
}
async function init$1({
  wallet,
  onomyRpcUrl,
  nomContractAddress,
  bondContractAddress,
  gravityContractAddress,
  wEthUsdtUniswapPoolAddress = "",
  ethGasPriceUrl = ""
}) {
  OnomyHubConstants.ETH_GAS_PRICE_URL = ethGasPriceUrl;
  const [onomy, ethereum] = await Promise.all([
    OnomyChain.init({ wallet, onomyRpcUrl }),
    EthereumChain.init({ wallet })
  ]);
  const bc = BondingCurve.init({
    chain: ethereum,
    nomContractAddress,
    bondContractAddress
  });
  const chains = { onomy, ethereum };
  const prices = new OnomyAssetPrices(chains, bc, wEthUsdtUniswapPoolAddress);
  const balances = new OnomyDetailedBalances(new OnomyAssetBalances(chains), prices);
  const delegations = new OnomyDelegations(chains, balances);
  const proposals = new OnomyGovProposals(chains);
  const bridges = [
    new BridgeBNomToNom(gravityContractAddress, chains, prices, balances),
    new BridgeEthNomToNom(gravityContractAddress, chains, prices, balances),
    new BridgeNomToEthNom(chains, prices, balances)
  ];
  return {
    chains,
    prices,
    balances,
    delegations,
    bridges,
    proposals,
    TransferAsset: TransferAsset.init(chains, balances),
    DelegateAsset: DelegateAsset.init(chains, balances, delegations),
    UndelegateAsset: UndelegateAsset.init(chains, balances, delegations),
    RedelegateAsset: RedelegateAsset.init(chains, balances, delegations),
    ClaimReward: ClaimReward.init(chains, balances, delegations),
    MoveDelegation: MoveDelegation.init(chains, balances, delegations),
    BuyBridgeNom: BuyBridgeNom.init(bc.actions, balances),
    SellBridgeNom: SellBridgeNom.init(bc.actions, balances),
    BondingCurve: bc,
    getSupportedAssets() {
      return OnomyHubUtils.getSupportedAssets();
    },
    getAddresses() {
      return OnomyHub._.getAddresses(wallet);
    },
    getAssetMeta(asset) {
      return OnomyHubUtils.getAssetMeta(asset);
    },
    isAddressValid(address) {
      return OnomyHubChains.isAddressValid(chains, address);
    },
    suggestGasPrices(params) {
      return OnomyHubChains.suggestGasPrices(chains, params);
    },
    getAssetAddress(assetOrChain) {
      return OnomyHubChains.getAssetAddress(chains, assetOrChain);
    }
  };
}
const OnomyHub = {
  init: init$1,
  Utils: OnomyHubUtils,
  _: {
    getAddresses
  }
};

function init({
  wallet: core,
  onomyChainId,
  onomyChainInfo,
  ethWsUrl
}) {
  const onomyWallets = core.getCosmosWallets(onomyChainId, onomyChainInfo);
  const ethWallets = core.getEthereumWallets(ethWsUrl);
  const cosmos = core.cosmos(onomyChainId, onomyChainInfo);
  const ethereum = core.ethereum(ethWsUrl);
  return { core, onomyWallets, ethWallets, cosmos, ethereum };
}
const OnomyHubWallet = {
  init
};

class ThrottledAsyncCache extends AbstractThrottledAsyncCache {
  constructor(fn, keyFn) {
    super();
    this.fn = fn;
    this.keyFn = keyFn;
  }
  cacheKey(args) {
    const typedArgs = args;
    return this.keyFn(...typedArgs);
  }
  async implementation(...args) {
    const res = await this.fn(...args);
    return res;
  }
}

export { AbstractAssetBridge, AbstractGravityBridge, AbstractThrottledAsyncCache, BridgeBNomToNom, BridgeEthNomToNom, BridgeNomToEthNom, NomBondingCurve, OnomyAssetPrices, OnomyDelegations, OnomyDetailedBalances, OnomyGovProposals, OnomyHub, OnomyHubConstants, OnomyHubUtils, OnomyHubWallet, ThrottledAsyncCache };
